// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg viewBox=\"0 0 1263 178\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 0 0 C 44 0 44 50 88 50 L 88 50 L 88 0 L 0 0 Z\" stroke-width=\"0\"></path> <path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 87 50 C 128.5 50 128.5 8 170 8 L 170 8 L 170 0 L 87 0 Z\" stroke-width=\"0\"></path> <path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 169 8 C 254.5 8 254.5 94 340 94 L 340 94 L 340 0 L 169 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 339 94 C 415 94 415 51 491 51 L 491 51 L 491 0 L 339 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 490 51 C 525.5 51 525.5 82 561 82 L 561 82 L 561 0 L 490 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 560 82 C 607.5 82 607.5 34 655 34 L 655 34 L 655 0 L 560 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 654 34 C 719 34 719 57 784 57 L 784 57 L 784 0 L 654 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 783 57 C 857.5 57 857.5 4 932 4 L 932 4 L 932 0 L 783 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 931 4 C 1021.5 4 1021.5 42 1112 42 L 1112 42 L 1112 0 L 931 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 1111 42 C 1187 42 1187 0 1263 0 L 1263 0 L 1263 0 L 1111 0 Z\" stroke-width=\"0\"></path></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg viewBox=\"0 0 1263 213\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 0 77 C 28 77 42 52 70 52 L 70 52 L 70 0 L 0 0 Z\" stroke-width=\"0\"></path> <path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 69 52 C 123.80000000000001 52 151.2 78 206 78 L 206 78 L 206 0 L 69 0 Z\" stroke-width=\"0\"></path> <path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 205 78 C 289.4 78 331.6 21 416 21 L 416 21 L 416 0 L 205 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 415 21 C 459.4 21 481.6 93 526 93 L 526 93 L 526 0 L 415 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 525 93 C 563.8 93 583.2 69 622 69 L 622 69 L 622 0 L 525 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 621 69 C 652.6 69 668.4 95 700 95 L 700 95 L 700 0 L 621 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 699 95 C 749.8 95 775.2 43 826 43 L 826 43 L 826 0 L 699 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 825 43 C 913 43 957 96 1045 96 L 1045 96 L 1045 0 L 825 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba%2832, 86, 115, 1%29\" d=\"M 1044 96 C 1131.6 96 1175.4 31 1263 31 L 1263 31 L 1263 0 L 1044 0 Z\" stroke-width=\"0\"></path></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public//img/home_img.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%271600%27 height=%27198%27 preserveAspectRatio=%27none%27%3e%3cdefs%3e%3clinearGradient id=%27a%27 x1=%2750%25%27 x2=%2750%25%27 y1=%27-10.959%25%27 y2=%27100%25%27%3e%3cstop stop-color=%27%237dd3fc%27 stop-opacity=%27.25%27 offset=%270%25%27/%3e%3cstop stop-color=%27%237dd3fc%27 offset=%27100%25%27/%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill=%27url%28%23a%29%27 fill-rule=%27evenodd%27 d=%27M.005 121C311 121 409.898-.25 811 0c400 0 500 121 789 121v77H0s.005-48 .005-77z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public//img/map_page.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/img/blur_map_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../public//img/3.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --hydrosblue: #205673;
  --hydrosorange:#DA6B51;
  --hydroslightblue:#327F98;
  --hydrosyellow:#FDEDC4;
}




.App {
  text-align: center;
  overflow-x: hidden;
  min-height: 87vh;
  overflow-y: hidden;
}

.white-paragraph {
  color: white;
  font-size: 18px;
  font-weight: 500;
  text-align: justify;
}

.question_container {
  margin:auto;
  margin-top: 2vh;
  border-width: 4px;
  border-color: var(--hydrosblue);
  border-style: solid;
  border-radius: 20px;
  padding: 2vw;
  min-width: 25rem;
  z-index: 22;
  position: relative;
min-width: 18rem;
margin-bottom: 1rem;}

.graphique_empreinte_div {
  margin: auto;
  min-width: 20rem;
}

.question-graphique-title {
  text-align: left;
  color: var(--hydrosblue);
  z-index: 22;
  position: relative;
  transform: translate3d(0, 0, 0);
  margin: 0REM;
  font-weight: bolder;
}

.global-question-container {
  margin: auto;
  width: 85%;
  max-width: 110vh;
}

.question-total {
  text-align: right;
  color: var(--hydrosblue);
  font-size: xx-large;
  border: solid 5px var(--hydrosorange);
  border-radius: 20px;
  padding: 0.25rem;
}

.question_info_container {
  text-align: left;
  background-color: #F7F7F7;
  border-radius: 25PX;
  padding: 1rem;
}

.text_info {
  text-align: left;
  margin-bottom: 1vh;
}

.question_title_container {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  margin-bottom: 1vh;
}

.question-total-container {
    border-radius: 25px;
    margin-left: auto;
    margin-right: auto;
    margin-top: -10px;
}

.question_title {
  font-size: x-large;
  padding-right: 1vw;
  text-align: left;
}
.navigation_container {
  display: flex;
  justify-content: right;
  margin-top: 25px;
}

.button-hydros {
  align-items: center;
  background-color: var(--hydrosblue);
  border: 0;
  border-radius: 100px;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font-family: 'Marianne', sans-serif;
  font-size: 16px;
  font-weight: 600;
  justify-content: center;
  line-height: 20px;
  max-width: 480px;
  min-height: 40px;
  min-width: 0px;
  overflow: hidden;
  padding: 0px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  touch-action: manipulation;
  transition: background-color 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s,
    box-shadow 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s,
    color 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: middle;
  margin-left: 2vw;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
}

.button-hydros:hover,
.button-hydros:focus,.boutton-sensibiliser:hover,.boutton-sensibiliser:focus {
  background-color:  rgb(29, 77, 104)!important;
  color: #ffffff;
}

.boutton-commencer:hover,.boutton-commencer:focus {
  background-color:  #C46049;
  color: #ffffff;
}



.button-hydros:active{
  background: #09223b;
  color: rgb(255, 255, 255, 0.7);
}
  

.button-hydros:disabled {
  cursor: not-allowed;
  background: rgba(0, 0, 0, 0.08);
  color: rgba(0, 0, 0, 0.3);
}

.boolean-button {
  align-items: center;
  background-color: rgb(255, 255, 255);
  border-color: rgb(227, 227, 219);
  border-radius: 12px;
  border-style: solid;
  border-width: 2px;
  padding: 1vh 2vh;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0.5vh;
  cursor: pointer;
}

.selected {
  align-items: center;
  background-color: rgb(255, 255, 255);
  border-color: var(--hydrosblue);
  border-radius: 12px;
  border-style: solid;
  border-width: 2px;
  padding: 1vh 2vh;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0.5vh;
  font-size: initial;
}

.empreinte-eau-definition {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;

  text-align: left;
  padding: 0vw 5vw;
  padding-bottom: 3vw;

  background-color: var(--hydrosorange);
}


.hydros-teaser-title {
  color: white;
  font-size: 40px;
  text-align: center;
}

.hydros-text-white {
  color: white;
  font-size: 20px;
  text-align: justify;
}

.hydros-image {
  width: 100%;
}





.not-selected {
  align-items: center;
  background-color: rgb(255, 255, 255);
  border-color: rgb(227, 227, 219);
  border-radius: 12px;
  border-style: solid;
  border-width: 2px;
  padding: 1vh 2vh;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0.5vh;
  font-size: initial;
}

.selected:hover, .not-selected:hover {
  background-color: rgb(240 244 253);
}

.choices_container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
}

.typeJsText {
  min-width: 10%;
  text-align: left;
}

.arrow-img {
  height: 2vh;
  width: 2vh;
}
.info-img {
  height: 4vh;
  width: 4vh;
  cursor: pointer;
}

.info-empreinte {
  height: 4vh;
  width: 4vh;
  cursor: pointer;
}

.info-action {
  cursor: pointer;
  height: 2.5vw;
    width: 2.5vw;
    min-height: 2rem;
    min-width: 2rem;
}


.results-img {
  height: 1.25rem;
  width: 1.25rem;
  z-index: 22;
  position: relative;
}


.graph-results-img {
  width: 5vw;
  min-height: 2rem;
  min-width: 2rem;
  cursor: pointer;
}

.graph-results-title {
  display: flex;
  justify-content: flex-start;
}

.graph-title-and-results-container {
  display: flex;
  flex-direction: column;
  gap: 1vh;
  width: 100%;
}

.mosaic-option-img {
  height: 6vh;
  width: 6vh;

}
.boutton-commencer {
  align-items: center;
  background-color: var(--hydrosorange);
  border-color: var(--hydrosorange);
  border-radius: 25px;
  border-style: solid;
  border-width: 2px;
  color: white;
  padding: 20px 40px;
  font-size: large;
  cursor: pointer;
  font-weight: bold;
  z-index: 9999;
  position: RELATIVE;
  text-decoration: none;
}

.boutton-orange {
  color: var(--hydrosorange)!important;
  background-color: white!important;
}

.close_text_info_button  {
  margin-left: 0vw!important;
}
h1 {
  font-size: x-large;
  font-weight: bold;
  color:  var(--hydrosblue);
}

h2 {
  font-weight: 500;
}

.header-container {
  top: 0; 
  left: 0;
  width: 100%; 
  background-color: white; 
  z-index: 1000; 
  border-bottom: solid rgb(227, 227, 219) 1px;
  background-color: var(--hydrosblue);
  
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, ;
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  max-width: 100rem;

  color: white;
  padding: 0.5rem 2rem;
  
  
}

.footer {
  display: flex;
  flex-direction: row;
gap: 3vw;
justify-content: center;
background-color: var(--hydrosblue);
color: white;}


.header-content, .footer-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: large;
  cursor: pointer;
  gap: 1rem;
}

.no-link {
  color:white;
  text-decoration:none
}



.compte-gouttes-icon, .compte-gouttes-footer-icon {
  width: 24vH;
  cursor: pointer;
}

.ademe-icon {
  height: 6vw;
  cursor: pointer;
}

.liste-icon {
  height: 5vh;
  width: 5vh;
}

.hamburger-icon {
  display: none;
  height: 6vh;
  width: 6vh;
}

.dynamic-text {
  width: 100%;
  flex-wrap: wrap;
  display: flex;
  gap: 6px;
  margin-left: auto;
}
.paragraphe-nos-gestes {
  display: flex;
  flex-direction: row;
  padding: 10vh 0vh;
  justify-content: center;
  margin-right: auto;
  margin-left: auto;
  max-width: 80%;
  padding: 0vh 3vw;
  gap: 7rem;
align-items: center;
text-align: center;
margin-top: -40px;
margin-bottom: 5%;
}

.paragraphe-empreinte-eau {
  display: flex;
  flex-direction: row;
  padding: 10vh 0vh;
  justify-content: center;
  margin-right: auto;
  margin-left: auto;
  max-width: 65vw;
  padding: 0vh 3vw;
  gap: 7rem;
  align-items: center;
  text-align: center;
  margin-top: -205px;
}

.description-seo-text {
  text-align: justify;
}

.parent-paragraphe-empreinte-eau {
  background-color: var(--hydrosblue);
  padding-bottom: 4rem;
}



.paragraphe-nos-gestes-title {
  color: var(--hydrosblue);
font-size: x-large;
justify-content: center;}

.hydros-teaser-left-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.img-atelier-compte-gouttes {
  max-width: 130%;
}

.img-hydros-teaser {
  max-width: 100%;
}

.img-plus-loin {
  max-width: 45%;
}

.wf-paragraphe {
  background-color: rgb(243 244 246);
}

.home-button-new-form {
  position: relative;
  z-index: 9999;
  cursor: pointer;
  margin-top: 15px;
  /* color: var(--hydrosblue); */
  color: #000b10;
}

.home-button-new-form:hover {
  text-decoration: underline;
}



.home-separator {
  display: block;
 position: relative;
 top: -2px;
 height: 178px;
 background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
 background-size: cover;
 background-repeat: no-repeat;
 }

 .home-separator-bottom {
  display: block;
 position: relative;
 top:  -215px;
 height: 235px;
 background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
 background-size: cover;
 background-repeat: no-repeat;
 transform: rotate(180deg);
 }
 
 
 /* @media (max-width:1246px) {
  .home-separator, .home-separator-bottom {
    background-size: contain;
  }
 } */
 

.suggestion_container {
  padding: 4vh;
  text-align: right;
  padding-right: 0;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.answer_container {
  text-align: right;
}

.answer_input {
  border: 2px solid rgb(227, 227, 219);
  border-radius: 12px;
  padding: 1vh;
  margin-left: 1vw;
}

.checkbox-round {
  width: 1.3em;
  height: 1.3em;
  background-color: white;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid #696969;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
}

.checkbox-round:checked {
  background-color: var(--hydrosblue);
    border: WHITE 2px solid;
    outline: var(--hydrosblue) solid 2px;
}

input[type="checkbox"] {
  margin-right: 0.5vw;
}

.paragraph1-flex-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 32rem;
  /* background-image: url('../public//img/11.svg'); */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); 
  background-position: bottom;
  background-size: contain;
  background-repeat: no-repeat;
  padding: 3vh;
  padding-bottom: 14vh;
  background-color: rgba(255, 255, 255, 0.8); /* Couleur de fond avec opacité */
  margin-top: 0px;
}

.plus-loin-container {
  display: flex;
  gap: 10rem;

}
.splash-img {
  position: absolute;
  left: 0;
}

.paragraph1-text {
  width: 70%;
}
strong {
  color: var(--hydrosblue);
  font-weight: 500;
}

.header-right {
  gap: 6rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.header-left {
  gap : 6rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.header-slider {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 5000;
  background-color: white;
  display: none;
  width: 14rem;
}

.header-slider-container {
  padding: 2vh;
  padding-top: 6vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 1vh;
  background-color: var(--hydrosblue);
  color: white;
}

.profile-icon-phone {
  height: 3vw;
  width: 3vw;
  min-width: 1rem;
  min-height: 1rem;
  margin-right: 1rem;
}

.header-slider-item {
  padding: 0.5rem;
  cursor: pointer;
}

/*image hamburger to cross transition*/
.container {
  position: relative;
  padding: 1.5rem;
}

.menu-toggle {
  position: relative;
  right: 1.5rem;
  top: 49%;
  transform: translate(0, -50%);
  height: 26px;
  width: 29px;
  z-index: 9999;
  display: none;
  cursor: pointer;

  &, &:hover {
    color: #000;
  }
}

.menu-toggle-bar {
  display: block;
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 0;
  width: 100%;
  height: 4px;
  border-radius: 4px;
  background-color: white;
  transition: all 0.3s ease;
}

.menu-toggle-bar.menu-toggle-bar--top {
  transform: translate(0, -8px);
}

.menu-toggle-bar.menu-toggle-bar--middle {
}

.menu-toggle-bar.menu-toggle-bar--bottom {
  transform: translate(0, 8px);
}

.nav-open .menu-toggle-bar.menu-toggle-bar--top {
  transform: translate(0, 0) rotate(45deg);
}

.nav-open .menu-toggle-bar.menu-toggle-bar--middle {
  opacity: 0;
}

.nav-open .menu-toggle-bar.menu-toggle-bar--bottom {
  transform: translate(0, 0) rotate(-45deg);
}


.mosaic-options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2vh; 
  padding: 2vh;
}

.mosaic-option {
  display: flex;
  background-color: white;
  border-radius: 25px;
  border: solid 2px rgb(227, 227, 219);
  padding: 2vh 1vw;
  gap: 1vh;
  align-items: center;
  justify-content: space-between;
}

.number-input {
  border: none;
  width: 3vw;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mosaic-number-input-container {
  display: flex;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0; /* Optional: Remove default margin */
}

.suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-end;
  padding-top: 10px;
  
}

/* For Firefox */
input[type="number"] {
  -moz-appearance: textfield; /* Reset Firefox style */
}


.navigation-links {
  display: flex;
  gap: 2vw;
  padding: 2vh 0px;
  flex-wrap: wrap;
}

.footer-logo {
  display: flex;
  justify-content: flex-end;
}

.footer-navigation {
  display: flex;
  gap:5rem;
  width: -webkit-fill-available;
  max-width: 60vw;
}


.results-direct {
  background-color: rgb(162, 210, 253);
  height: 6vh;
  border: solid 1px white;
  align-content: center;
  justify-content: center;
  display: FLEX;
  padding-top: 0.5vh;
  padding-bottom: 0.5vh;
}

.results-indirect {
  background-color: rgb(162, 210, 253);
  height: 6vh;
  border: solid 1px white;
  align-content: center;
  justify-content: center;
  display: FLEX;
  padding-top: 0.5vh;
  padding-bottom: 0.5vh;
  min-width: 4rem;
}

.results-ul {
   list-style-type:none;
   padding: 0; 
   display: flex;
   z-index: 22;
    position: relative;
    transform: translate3d(0, 0, 0);
   
}

.component-graphique-vague-container {
  
}

.results-vague {
  list-style-type:none;
  padding: 0; 
  display: flex;
  align-items: center;
  
  width: 5rem;
  /* animation: animate 4s infinite; */
  flex-direction: column;
  border-radius: 25px;
  position: absolute;
  height: 100%;
  top: 0;
  left:0;
  z-index: 1;
  height: 30rem;
}

.results-vague:nth-child(2) {
  background: #7dd3fc;
  animation-name: animate;           
  animation-duration: 4s;            
  animation-delay: 0s; 
  
  z-index: 2;
}





.circle-img {
  border-radius: 50%;
    width: 6vh;
    height: 6vh; 
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
}

.circle-plus-loin {
  border-radius: 50%;
    width: 15vh;
    height: 15vh; 
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
}

.titre-container {
  height: 5rem;
  align-items: center;
  display: flex;
  align-content: center;
}
.titre {
  border-radius: 25px;
  background-color: white;
  color: var(--hydrosblue);
  padding: 0.5rem;
  max-width: 10rem;
    font-size: large;
    font-weight: bold;
  
}

.results-page {
  margin-top: 12vh;
}

.results-principaux {
  height: 4vh;
    border: solid 1px white;
    align-content: center;
    justify-content: center;
    display: FLEX;
    min-width: 3vw;
    padding-top: 0.5vh;
    padding-bottom: 0.5v
}

.results-direct:first-of-type, .results-indirect:first-of-type{
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
}

.results-indirect:last-of-type, .results-direct:last-of-type {
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
}

.graphique-vague-container {
  justify-content: center;
  position: relative;
  height: 30rem;
  margin-bottom: 2rem;
 
}

/*vague qui se remplit plus le questionnaire avance*/


.results-vague::after {
  content: "";
  position: absolute;
  width: 29REM; /* default value */
  height: 29REM;
  left: 55%;
  background-color: rgba(255, 255, 255, 0.18);
  border-radius: 70%;
  transform: translateX(-50%) rotate(0);
  animation: rotate 6s linear infinite;
  z-index: 10;
  margin-top: var(--pseudo-margin, -1rem);
}

.results-vague::after {
  border-radius: 30%;
  /* background-color: rgba(91, 9, 9, 0.9); */
  background-color: white;
  animation: rotate 10s linear -5s infinite;
  z-index: 20;
}


@keyframes rotate {
  100% {
      transform: translateX(-50%) rotate(360deg); /* Full rotation */
  }
}

/* wave effect pour empreinte eau indirecte */



.empreinte-eau-type {
  z-index: 22;
  position: relative;
}

.results-box {
  border: solid 5px #DB6C52;
  border-radius: 25px;
  margin-left: auto;
  margin-right: auto;
  width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 2vh;
  margin-top: 2vh;
  background-color: lightblue;
  border-top: none;
}

.results-france {
  border: solid 5px var(--hydrosblue);
  border-radius: 25px;
  width: 17%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.5rem;
  position: relative;
  margin-left: 3rem;
}

.partager-results {
  border-radius: 25px;
  width: 17%;
  display: flex;
  flex-direction: column;
  gap:2rem;
  padding: 0.5rem;
  margin-top: auto;
    margin-bottom: auto;
    margin-left: 3rem;
    align-items: center;
  border: solid 5px gray;
}

.results-info {
  border: solid 5px GRAY;
  border-radius: 25px;
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
}

.results-title {
  display: flex;
  justify-content: flex-start;
  padding-bottom: 0.5rem;
  font-size: x-large;
  z-index: 22;
  align-items: center;
  gap: 1vw;
  text-align: left;
  position: relative;
  z-index: 22;
  height: 3rem;
  padding-left: 1rem;
}

.mon-empreinte-eau {
  height: 4rem;
}

.grands-postes-title {
  display: flex;
  justify-content: flex-start;
  padding: 1rem;
  font-size: x-large;
  z-index: 22;
  align-items: center;
  gap: 1vw;
  text-align: left;
  position: relative;
  z-index: 22;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  color:var(--hydrosblue);
}

.progression {
  height: 12px;
  margin-top: 1vh;
  border-radius: 25px;
  margin-left: auto;
  margin-right: auto;
 background-color: #F7F7F7;
 color:#F7F7F7;
}

.progress-done {
	background: var(--hydrosblue);
	border-radius: 20px;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 0;
	opacity: 0;
	transition: 1s ease 0.3s;
}

.dialogue {
  border-radius: 50px;
  border: solid 1px BLACK;
  PADDING: 15px;
  width: 7rem;
  height: min-content;
  cursor: pointer;
}

.dialogue_clic {
  border-radius: 50px;
  background-color: #f7f7f7;
  PADDING: 15px;
  height: min-content;
  cursor: pointer;
  position: relative;
  text-align: justify;
  font-style: italic;
  padding-left: 28px;
  padding-right: 28px;
  font-size: 14px;
}

.walter-icon-behind {
  height: 3rem;
  width: 3rem;
  position: absolute;
  top: -30px;
  left: 30px;
  cursor: pointer;
}

.walter-icon-base {
  height: 6rem;
  cursor: pointer;
}

.results-empreinte {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  font-size: xx-large;
  font-weight: 500;
  border-top: dotted 5px gray;
  z-index: 22;
  position: relative;
  height: 3rem;
}

.results-equivalent {
    display: flex;
    justify-content: flex-start;
    padding-bottom: 0.5rem;
    z-index: 22;
    align-items: center;
    gap: 1vw;
    text-align: left;
    position: relative;
    z-index: 22;
    height: 3rem;
    padding-left: 1rem;
}
.page-results-img {
  height: 3rem;
  width: 3rem;
}

.france-img {
  height: 5vw;
  width: 5vw;
  min-height: 2rem;
  min-width: 2rem;
}

.carousel-img {
  height: 5vw;
  width: 5vw;
  min-height: 3rem;
  min-width: 3rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.eau-img {
  height: 2vw;
  width: 2vw;
  min-height: 1rem;
  min-width: 1rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.results-box-container {
  display: flex;
  flex-direction: row;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  margin-bottom: 3%;
  gap: 0px;
  justify-content: center;
}

.main-results {
  display: flex;
    flex-direction: column;
    width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

.circle {
  width: 2.5rem; 
  height: 2.5rem; 
  border: solid 2px black;
  border-radius: 50%; 
  padding: 0.5rem; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  box-sizing: border-box; 
}

.results-one {
  BACKGROUND-COLOR: #F7F7F7;
  border-radius: 25px;
  PADDING: 1rem 1REM;
  display: flex;
  gap: 2rem;
  margin-top: 2vh;
  align-items: center;
}

.grands-postes-results {
  background-color: rgba(162, 210, 253, 0.7);
    height: 3vh;
    border: solid 0.35rem rgba(162, 210, 253);
    align-content: center;
    justify-content: flex-end;
    display: FLEX;
    padding-top: 0.5vh;
    padding-bottom: 0.5vh;
    min-width: 14%;
    border-radius: 25px;
    padding-right: 1rem;
    align-items: center;
}

.circle-img-vague {
  position: relative;
  display: inline-block;
}

.circle-img-vague .tooltip {
  width: 12rem;
  height: 4rem;
  border: 1px solid black;
  text-align: center;
  border-radius: 25px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  left: 5rem;
  bottom: 1.5rem;
  overflow: hidden; /* Ensure wave stays within the border radius */
  z-index: 22;
}

.paragraphe-empreinte-eau-container .paragraph1-title, .paragraphe-empreinte-eau-container{
  color: white!important ;
}

.paragraph1-title {
  font-size: 40px;
}

.agir-blue-title, .action-valeur, .action-title, .total-empreinte,.paragraphe-nos-gestes-item,.paragraphe-nos-gestes-title, .introduction {
  font-size: 20px;
  font-weight: 400;
}

.valeur-agir {
  font-size: 23px;
  font-weight: 700;
}

.introduction {
  font-size: 25px;
  color: grey;
  font-weight: 500;
}

.empreinte-eau-bloc {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}




.waves {
  position:absolute;
  width: 100%;
  height:15vh;
  margin-bottom:-7px; /*Fix for safari gap*/
  min-height:100px;
  max-height:150px;
  
}

.pie-chart-container {
  width: 100%;
  height:100%;
}

.repartition-container {
  display: flex;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  gap: 0px;
  justify-content: center;
  margin-bottom: 20px;
}

.piecharts-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  color: var(--hydrosblue);
  font-size: 20px;
  font-weight: 600;
}

.total-empreinte {
  display: flex;
  color: #6f6f6f;
  font-size: 24px;
  padding-bottom: 2vh;
  font-weight: 500;
}

.repartition-section-directe {
  border: solid 5px #DB6C52;
  border-radius: 25px;
  padding: 2vh;
  width: 90%;
}

.repartition-section-indirecte {
  border: solid 5px #5E3967;
  border-radius: 25px;
  padding: 2vh;
  margin-left: 3rem;
  width: 90%;
}

.agir {

  display: flex;
  justify-content: space-between;
}

.action {
  border: solid 5px rgb(249 205 73);
  border-radius: 25px;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  background-color: rgba(249, 205, 73, 0.218);
}

.agir-icons{
  font-size: xxx-large;
  align-content: center;
}

.action-valeur {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  font-size: 23px;
  font-weight: 700;
  color: var(--hydrosblue);
  align-items: end;
  margin-top: 5px;
}

.comment-agir-titre {
  display: flex;
  gap: 6vh;
  width: 80%;

}

.agir-blue-title {
  font-size: 20px;
  display: flex;
  font-weight: 700;
  align-items: center;
  gap: 0.5rem;
  text-align: left;
}

.percentage-text-agir {
  font-style: italic;
  color: #797979;
}

.agir-percentage-container {
  text-align: left;
}

.action-section {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

.empreinte-info {
  background-color:#F7F7F7;
  border-radius: 25px;
  padding: 1rem;
  text-align: justify;
  padding-left: 2rem;
  position: relative;
  margin-top: 40px;
  word-wrap: break-word;
  margin-bottom: 0px;
  font-style: italic;
  color: #343434;

}

.idee-img {
  height: 2rem;
  width: 2rem;
  position: absolute;
  left: 0%;
  top: -15px;
}

.action-title {
  /* color: var(--hydrosblue); */
  color: #1d4c02;
  font-size: 23px;
  text-align: left;
  margin-bottom: 1%;
  font-weight: 500;
}

.agir-content {
  margin-left: 5%;
  margin-bottom: 5%;
}

.action-description {
  margin-top: 10px;
  text-align: justify;
}


.agir-percentage{
  background-color: rgb(162, 210, 253);
    height: 2vh;
    align-content: center;
    justify-content: flex-end;
    display: FLEX;
    padding-top: 0.5vh;
    padding-bottom: 0.5vh;
    min-width: 4rem;
    border-radius: 25px;
    padding-right: 1rem;
    align-items: center;
    margin-top: 5px;
}



/*TEST AGAIN*/

.detail-footprint-question-container {
  width: 100%;
}

.box {
  position: relative;
  height: 50%;
  border: solid 5px #DB6C52;
  border-radius: 25px;
  z-index: 22;
  width: 60%;
}

.tooltip-box {
  position: relative;
  height: 50%;
  border-radius: 25px;
  z-index: 22;
 
}

.box-inner {
  position: relative;
  width: 100%;
}

.tooltip {
  height: 4rem;
  border: 4px solid var(--hydrosblue)
}

.tooltip,.tooltip-box:before,.question-box-inner,.box:before,
.box-inner {
  background-color: white;
  border-radius: 21px;
  
  background-image: 
  url(${___CSS_LOADER_URL_REPLACEMENT_3___}),
  url(${___CSS_LOADER_URL_REPLACEMENT_3___}),
  url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  
  background-repeat: repeat-x;
  background-size: 1600px var(--pseudo-margin-top, 50%);
  background-position: 0 130%, -50px 130%, 500px 130%;
  
  animation: 20s waves linear infinite forwards;
}

@keyframes waves {
  to {
    background-position: 1600px 130%, 3150px 130%, 5300px 130%;
  }
}

.results-france:before {
  content: "";
    position: absolute;
    top: 7rem;
    margin-top: -1.75rem;
    left: -3rem;
    border: solid 23px transparent;
    border-right-color: var(--hydrosblue);
    z-index: 1;
}


/*carousel d'image page d'acceuil*/

body{
 
  --Vitesse: 25s; /* Vitesse de défillement (dépend de la longeur du texte) */
}
    
.container-carousel{
  height: 10vh;
  width: 100%;
  display: flex;
  align-items: center;
  margin-left: -57%;
  margin-bottom: 3rem;
}
  
.text{
  white-space: nowrap;
  animation : Scroll var(--Vitesse) linear infinite; 

}
  
@keyframes Scroll {
  0% {transform: translateX(0%); } /* inversé 0% et 100% pour inversé le sens */
  100% {transform: translateX(-100%); }}



.tshirt-map {
  width: 70%;
  margin-top: 30px;
}

.actions-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.green-yellow-purple-gray-map {
  width: 50%;
}

.green-yellow-purple-gray-map-container {
  display: flex;
  gap: 3rem;
}

.empreinte-par-pays-container {
  display: flex;
    flex-direction: column;
}

.empreinte-par-pays-div {
  border-radius: 25px;
  padding: 0.5rem 0;
  display: flex;
  gap: 2rem;
  align-items: center;
}

.bg {
	display: block;
	width: 50%;
	height: 0;
	padding-bottom: 35%;
	background-position: top center;
	background-size: 100%;
	transition: background-position 3s ease-in-out, box-shadow 3s ease;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  margin-left: auto;
  margin-right: auto;
cursor: pointer;}

  .bg:hover {
    background-position: bottom center;
    box-shadow: inset 0 20px 20px rgba(0,0,0,0.2);
  }


.api-vigieau {
  background-color: #F7F7F7;
  padding: 15px 30px;
  border-radius: 50px ;
  margin-top: 1rem;
}

.api-vigieau-vigilance {
  font-Size:'x-large';

}
/* -----------------CONTACT PAGE-------------------------------------------*/

.contact-page {
  display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); 
    justify-content: center;
    gap: 7rem;
    max-width: 60%;
    margin-right: auto;
    margin-left: auto;
    padding: 0vh 3vw;
    align-items: center;
    text-align: left;
    margin-bottom: 5%;
    color: var(--hydrosblue);
  
  
}

.form-group {
  gap: 1rem;
    display: flex;
    flex-direction: column;
}

.results-form {
  gap: 1rem;
    display: flex;
    flex-direction: row;
}

.formulaire {
  border-radius: 25px;
  border: solid 2px BLACK ;
  margin-bottom: 10px;
  padding: 10px;
}

@keyframes loading {
  from {
      transform: rotate(0deg);
  }
  to { 
      transform: rotate(360deg);
  }
}

.load {
width: 20px;
height: 20px;
margin-left: 30px;
border:solid 10px var(--hydrosblue);
border-radius: 50%;
border-right-color: transparent;
border-bottom-color: transparent;
 -webkit-transition: all 0.5s ease-in;
  -webkit-animation-name:             loading; 
  -webkit-animation-duration:         1.0s; 
  -webkit-animation-iteration-count:  infinite;
  -webkit-animation-timing-function: linear;
    
     transition: all 0.5s ease-in;
  animation-name:             loading; 
  animation-duration:         1.0s; 
  animation-iteration-count:  infinite;
  animation-timing-function: linear; 
}

.echec-status {
  background-color: #fecaca;
  border-radius: 25px;
  PADDING: 0.75rem;
  align-items: center;
  display: flex;
  font-weight: bold;
  width: max-content;
}

.succes-status {
  background-color: rgb(247, 255, 247);
  border-radius: 25px;
  PADDING: 0.75rem;
  align-items: center;
  display: flex;
  font-weight: bold;
  width: max-content;
}

/*-------------------------------------A PROPOS PAGE ----------------------------------------------------*/

.a-propos-paragraphe {
  background-color: white;
  display: flex;
  gap: 10px; 
}

.sensibiliser-paragraphe {
  display: FLEX;
  gap: 10px; 
}

.qui-sommes-nous {
  display: flex;
  flex-direction: column;
  align-items: center;
width: 60%;
  text-align: left;
  padding: 0vw 5vw;
  padding-bottom: 1vw;
  color: var(--hydrosblue);
  text-align: justify;

  
}

.hydros-pour-agir {
  color: white!important;
  display: flex;
    flex-direction: column;
    align-items: center;
    text-align: left;
    padding: 0vw 5vw;
    padding-bottom: 1vw;
    width: 60%;
  text-align: justify;
}

.hydros-pour-agir-container{
  background-color: var(--hydrosblue)!important;
  padding-bottom: 20px;
 
}

.hydros-pour-agir-paragraphe {
  background-color: var(--hydrosblue)!important;
  display: flex;
    gap: 10px;
    padding-right: 5vw;
}

.sensibiliser {
  color: var(--hydrosblue)!important;
  display: flex;
    flex-direction: column;
    text-align: left;
    padding: 0vw 5vw;
    padding-bottom: 2rem;
    width: 60%;
    text-align: justify;
}



.sensibiliser-container {
  background-color: var(--hydrosyellow)!important;
  padding-bottom: 20px;

}

.sensibiliser-paragraphe {
  align-items: center;
  padding-right: 5vw;
}

.mesurer {
  color: white!important;
  display: flex;
    flex-direction: column;
    text-align: left;
    padding: 0vw 5vw;
    padding-bottom: 1vw;
    width: 60%;
  text-align: justify;
}


.mesurer-container {
  background-color: var(--hydroslightblue)!important;
  padding-bottom: 20px;
}
.mesurer-paragraphe {
  align-items: center;
  display: FLEX;
    gap: 10px;
    padding-left: 5vw;
}

.inspiration {
  color: var(--hydrosblue)!important;
  display: flex;
    flex-direction: column;
    text-align: left;
    padding: 0vw 5vw;
    padding-bottom: 1vw;
    width: 80%;
  text-align: justify;
}

.inspiration-container {
  padding-bottom: 20px;
}

.inspiration-paragraphe {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.inspiration-img-container{
  margin-top: 10px;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  width: 90%;
  align-items: center;
}

.inspiration-logo {
  width: 150px;
  height: 100%;
}


.boutton-a-propos {
  padding: 15px 30px!important;
}

.boutton-sensibiliser {
  padding: 15px 30px!important;
  background-color: var(--hydrosblue)!important;
  border-color: var(--hydrosblue)!important;
}

.mesurer-empreinte-img-container,.qui-sommes-nous-img-container,.sensibiliser-img-container {
  width: 40%;
}

/*-----------------------------------PAGE FAQ ------------------------------------------- */
.faq-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  line-height: 1.6;
}

.faq-button-container {
  text-align: center;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
}

.faq-title {
  text-align: center;
  color: var(--hydrosblue);
  margin-bottom: 40px;
}

.faq-item {
  margin-bottom: 30px;
}

.faq-question {
  font-size: 1.5rem;
  color: var(--hydroslightblue);
  margin-bottom: 10px;
}

.faq-answer {
  font-size: 1rem;
  color: #34495e;
  text-align: justify;
}

.faq-link {
  display: inline-block;
  margin-top: 10px;
  color: var(--hydrosorange);
  text-decoration: none;
}

.faq-link:hover {
  text-decoration: underline;
}

/*-----------------------------------PAGE CARTE ------------------------------------------- */

.results-map {
  border-radius: 25px;
  display: flex;
  gap: 2vw;
  margin-top: 2vh;
  align-items: center;
  width:30rem;
  padding-left: 10%;
}

.page-map-percentage-bar {
  align-content: center;
  justify-content: flex-end;
  display: FLEX;
  padding-top: 0.5vh;
  padding-bottom: 0.5vh;
  min-width: 14%;
  border-radius: 25px;
  padding-right: 1rem;
  align-items: center;
  background: var(--hydroslightblue);
  width: 50%;
  height: 1px;
  width: 100%;
}

.percentage-box {
  position: relative;
    height: 50%;
    border: solid 5px #DB6C52;
    border-radius: 25px;
    z-index: 22;
    width: 100%;
    padding: 0.5rem;
}

.comprendre-results {
  border-radius: 25px;
  padding: 0.5rem 3%;
  display: flex;
  gap: 2rem;
  align-items: center;
  
  
}

.comprendre-plus-intro {
  border-radius: 25px;
  padding: 1rem 1.5rem;
  margin: 0rem 3%;
  display: flex;
  gap: 2rem;
  align-items: center;
  background-color: #F7F7F7 ;
  text-align: justify;
}

.comprendre-results-box {
  border: 6px solid var(--hydrosblue);
  border-radius: 50px;
  padding: 0.25rem;
}

.comprendre-results-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.introduction-map {
  font-size: 20px;
  color: var(--hydrosblue);
  font-weight: 500;
  margin-top: 0px;
}

/* .map p {
  color: var(--hydrosblue);
  font-weight: bold;
} */

.map-title {
  color: var(--hydrosblue);
  font-weight: 600;
  font-size: 16px;
}

.comprendre-empreinte-pays-img {
  width: 3vw;
  min-height: 2rem;
  min-width: 2rem;
}

.comprendre-empreinte-pays-map {
  border-radius: 25px;
  display: flex;
  gap: 2vw;
  margin-top: 2vh;
  align-items: center;
  width:30rem;
  padding-left: 6%;
}


.blurmap-background-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
  background-position: center;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
}




.wsdm-tooltip {
  display: none;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 3px;
  pointer-events: none;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.wsdm-tooltip:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 100%;
  left: 50%;
  margin-left: -0.5rem;
  border-left: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;
  border-top: 0.5rem solid rgba(255, 255, 255, 0.95);
}

.results-map {
  padding-left: 5%;
}


/*légende map*/
#progress-bar-container {
	width: 4rem;
	height: 0.75rem;
	border-radius: 35px;
	overflow: hidden;
}

.progress-bar-child {
	width: 100%;
	height: 100%;
}

.progress {
	color: white;
	text-align: center;
	line-height: 75px;
	font-size: 35px;
	font-family: "Segoe UI";
	animation-direction: reverse;
	background: #e5405e;

	/* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to right, #ffedd5 0%, #ea580c 80%);
}

.small-circle-legend {
  width: 0.5rem;
  height: 0.5rem;
  border: solid 1px black;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background-color: #F7F7F7;}

  .circle-legend {
    width: 0.75rem;
    height: 0.75rem;
    border: solid 1px black;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background-color: #F7F7F7;}


.legend-container {
  color: var(--hydrosblue)
  ;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
}

.legend-container > span {
  font-weight: bold;
}


/*----------------------------animation apparition  */

.hidden {
  opacity: 0;
  transition: all 1s;
  filter: blur(5px);
  transform: translateX(-100%);
}

.show {
  opacity: 1;
  filter:blur(0);
  transform: translateX(0);
}

.input-container {
  display: flex;
  align-items: center;
  border: 2px solid #666; /* Adjust the color as needed */
  border-radius: 30px; /* Make sure this is half of the container height */
  overflow: hidden;
}






.send-result-container {
  margin: 20px;
  width: 65%;
  margin-left: 17%;
  margin-right: 17%;
  color: var(--hydrosblue);
}

.form-send-result {
  display: flex;
  align-items: center;
  border: 2px solid #666; 
  border-radius: 30px; 
  overflow: hidden;
  
  width: -webkit-fill-available;
}

.checkbox-consent-container {
  color: #989898;
  text-align: left;
  margin-left: 10px;
  margin-top: 10px;
  font-size: 12px;
  vertical-align: middle;
}

.email-input {
  flex: 1 1;
  border: none;
  padding: 10px 15px;
  border-radius: 30px 0 0 30px; /* Match the container radius */
  outline: none;
  font-size: 16px;
}

.submit-button {
  background-color: #1e5276; /* Adjust the color as needed */
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 0 30px 30px 0; /* Match the container radius */
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
  border-radius: 25px;
  font-weight: bold;
}

.submit-button:hover {
  background-color: #163a54; /* Darken the button color on hover */
}


.goutte-eau-img {
  height: 5vw;
  width: 5vw;
  min-height: 2rem;
  min-width: 2rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  cursor: pointer;
}

.couleur-empreinte-container {
  border: solid 5px var(--hydrosblue);
  border-radius: 25px;
  width: 80%;
    margin-left: 10%;
    margin-right: 10%;
    padding-bottom: 1rem;
    position: relative;
    
}


.couleur-empreinte-info {
  background-color: #F7F7F7;
  border-radius: 25px;
  padding: 1rem;
  text-align: left;
  position: relative;
  word-wrap: break-word;
  margin-bottom: 1rem;
  margin-left: 2rem;
  margin-right: 2rem;
  margin-top: 1rem;
}

p {
  margin-block-start: 0.5em;
  margin-block-end: 0.5em;
}
/*------------------------------------------------------media queries pour petit écran---------------------------------------------*/
@media (max-width: 1024px) { 

  .sensibiliser-titre {
    margin-bottom: 20px!important;
  }

  .sensibiliser {
    padding-bottom: 1vw;
  }

  .number-input {
    width: 6vh;
  }

  .results-vague {
    width: 3rem;
  }

  .question_container {
    margin-top: 3vh;
  }

  .results-direct,.results-indirect {
    height: 3vh;
  }

  .circle-img {
    width: 3vh;
    height: 3vh;
  }

  .paragraph1-flex-container {
    margin-top: -40px;
  }

  .repartition-section-directe, .repartition-section-indirecte {
    width: 80%;
  }

  .header-content {
    display: NONE;
    
  }

  .menu-toggle {
    display: block!important;
  }

  .compte-gouttes-footer-icon {
    display: none;
  }

  .ademe-icon {
    min-width: 2rem;
    min-height: 2rem;
}

  .repartition-container {
    flex-direction: column;
    align-items: center;
    width: 90%;

  }

  .repartition-section-indirecte {
    margin-top: 3rem;
    margin-left: 0rem;
  }

  .grands-postes-results {
    min-width: 25%;
  }

  .results-box-container {
    width: 100%;
    margin-left: 0;
    
  }




.comment-agir-titre {
  width: 100%;
  gap: 3vh;
}

.action {
  flex-direction: column;
    gap: 1vh;
    align-items: end;
}

.agir {
  padding-bottom: 0;
  flex-direction: column;
}

.valeur-agir {
  margin-bottom: 1rem;
}

.question_title {
  font-size: medium;
}





.piecharts-title {
  text-align: left;
}

.graph-results-title {
  text-align: left;
}

h1 {
  font-size: x-large;
}

.paragraph1-text {
  width: 70%;
}
.paragraphe-nos-gestes {
  margin-left: 0px;
    margin-right: 0px;
    max-width: 100%;
}

.grands-postes-results {
  height: 2vh;
}

.agir-percentage{
  height: 1vh;
}

.button-hydros, .submit-button, .email-input {
  font-size: 10px;
}

.button-hydros {
  min-height: 35px;
}

.contact-page {
  gap: 1rem;
}

.send-result-container {
  width: 80%!important;
  margin-left: 10%!important;
  margin-right: 10%!important;

}
}

/*------------------------------------------media queries pour telephone-----------------------------------------*/
@media (max-width: 768px) {

  .logo-compte-gouttes-bleu {
    display: none;
  }

  .titre-container {
    WIDTH: -webkit-fill-available;
}

.titre {
  max-width: -webkit-fill-available;
  WIDTH: -webkit-fill-available;
}
 

  .plus-loin-container {
    flex-direction: column;
    gap: 1rem;
    
  }

  .paragraphe-nos-gestes {
    flex-direction: column;
    margin-left: 0px;
    margin-right: 0px;
    gap: 0px;
    max-width: 100%;
    margin-top: -85px;
    
  }

  .paragraphe-empreinte-eau {
    margin-left: 0PX;
    margin-right: 0px;
    MAX-widTH: 100%
  }

  .paragraph1-text {
    width: 100%;
}

.paragraph1-flex-container {
  margin-top: 0px;
}

.empreinte-eau-definition {
  flex-direction: column;
}


  

  .circle {
    width: 1.5rem;
    height: 1.5rem;
  }
  
.paragraph1-flex-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); 
  background-position: bottom;
  background-size: auto 80%;
  }


.img-atelier-compte-gouttes {
  max-width: 100%;
}



.header {
  align-content: center;
  padding-right: 2vw;
}

.mosaic-options {
  grid-template-columns: repeat(1, 1fr); /* Creates 2 columns of equal width */

}

.navigation-links {
  flex-direction: column!important;
}

.footer-logo {
  display: flex;
  justify-content: flex-start;
}

.results-indirect {
  min-width: 3rem;
  max-width: 30rem;
}

.suggestion_container {
  flex-direction: column;
  
  
}

.results-box-container {
  flex-direction: column;
  margin-left: 0;
  width: 100%;
  align-items: center;
  gap: 1rem;
}

.results-france:before {
  visibility: hidden;
}

.results-france {
  width: 58%;
  margin-left: 0;
}

.partager-results {
  flex-direction: row;
  justify-content: center;
  width: 88%;
  margin-left: 0;
}

.btn-partage {
  min-width: 7rem;
}

.grands-postes-results {
  min-width: 35%;
  font-size: x-small;
}

.grands-postes-title {
  min-width: 35%;
  margin-left: 0%;
}

.results-title{
  font-size: small;
}

.btn-partage {
  padding-top: 5px; 
  padding-bottom: 5px; 
}

.agir-icons {
  font-size: xx-large;
}

.results-empreinte {
  font-size: xx-large;
}



.grands-postes-results {
  height: 1vh;
}

.results-empreinte {

  border-top: HIDDEN;
  
}

.box,.results-info {
  width: 90%;
}

.results-france {
  width: 88%;
}

.results-info {
  align-items: center;
}

.main-results {
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
}

.circle-img-vague .tooltip {
  height: 3rem;
}

.a-propos-paragraphe,.hydros-pour-agir-paragraphe,.sensibiliser-paragraphe,.mesurer-paragraphe {
  flex-direction: column;
  padding-right: 0px;
  padding-left: 0px;
}

.qui-sommes-nous,.mesurer-empreinte-img-container,.hydros-pour-agir-img-container,.qui-sommes-nous-img-container,.hydros-pour-agir,.sensibiliser-img-container,.sensibiliser,.mesurer {
  width: 90%!important;
  JUSTIFY-CONTENT: CENTER;
  PADDING: 0 5vw;
}

.inspiration-img-container{
  flex-direction: column;
}

.inspiration-logo {
  width: 200px;
  height: 100%;
  margin-top: 20px;
}




.qui-sommes-nous-img-container,.sensibiliser-img-container {
  padding-bottom: 20px;
}

.contact-page {
  gap: 1rem;
}

.green-yellow-purple-gray-map{
  width: 100%;
}

.green-yellow-purple-gray-map-container {
  flex-direction: column;
}

.page-map-percentage-bar { 
  max-width: 50vw;
  min-width: 10vw;
}

.tshirt-map {
  width: 100%;
}

.agir-percentage {
  max-width: 50%;
}
.submit-button {
  padding: 10px;
}


.bg {

  width: 60%!important;
  padding-bottom: 45%!important;
}

.api-vigieau-vigilance {
  font-Size:'medium';

}

.api-vigieau-department-container {
  text-align: left;
  flex-direction: column;
}

}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;;;;AAKA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB,gBAAgB;AAChB,mBAAmB,CAAC;;AAEpB;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,SAAS;EACT,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B;;gDAE8C;EAC9C,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;;EAEE,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;;;AAIA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;;AAGA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;;EAEnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;;EAEnB,qCAAqC;AACvC;;;AAGA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;;;;;AAMA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;;AAGA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;;AAEZ;AACA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,2CAA2C;EAC3C,mCAAmC;;EAEnC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;;EAEjB,YAAY;EACZ,oBAAoB;;;AAGtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB,QAAQ;AACR,uBAAuB;AACvB,mCAAmC;AACnC,YAAY,CAAC;;;AAGb;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX;AACF;;;;AAIA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX,mBAAmB;AACnB,kBAAkB;AAClB,iBAAiB;AACjB,iBAAiB;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;;;AAIA;EACE,wBAAwB;AAC1B,kBAAkB;AAClB,uBAAuB,CAAC;;AAExB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;;;AAIA;EACE,cAAc;CACf,kBAAkB;CAClB,SAAS;CACT,aAAa;CACb,yDAAu2C;CACv2C,sBAAsB;CACtB,4BAA4B;CAC5B;;CAEA;EACC,cAAc;CACf,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,yDAA4wC;CAC5wC,sBAAsB;CACtB,4BAA4B;CAC5B,yBAAyB;CACzB;;;CAGA;;;;IAIG;;;AAGJ;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mCAAmC;IACjC,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,oDAAoD;EACpD,yDAAqD;EACrD,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;EACZ,oBAAoB;EACpB,0CAA0C,EAAE,iCAAiC;EAC7E,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;;AAEZ;AACA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,eAAe;;EAEf;IACE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;AACA;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;;AAGA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,QAAQ;EACR,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,wBAAwB;EACxB,SAAS,EAAE,oCAAoC;AACjD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,iBAAiB;;AAEnB;;AAEA,gBAAgB;AAChB;EACE,0BAA0B,EAAE,wBAAwB;AACtD;;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,eAAe;AACjB;;;AAGA;EACE,oCAAoC;EACpC,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;GACG,oBAAoB;GACpB,UAAU;GACV,aAAa;GACb,WAAW;IACV,kBAAkB;IAClB,+BAA+B;;AAEnC;;AAEA;;AAEA;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,aAAa;EACb,mBAAmB;;EAEnB,WAAW;EACX,oCAAoC;EACpC,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,MAAM;EACN,UAAU;EACV,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;;EAEnB,UAAU;AACZ;;;;;;AAMA;EACE,kBAAkB;IAChB,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;IAChB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;IACd,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;IACT,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;;AAErB;;AAEA,oDAAoD;;;AAGpD;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY,EAAE,kBAAkB;EAChC,aAAa;EACb,SAAS;EACT,2CAA2C;EAC3C,kBAAkB;EAElB,qCAAqC;EAErC,oCAAoC;EACpC,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EAGvB,yCAAyC;EACzC,WAAW;AACb;;;AAGA;EACE;MACI,0CAA0C,EAAE,kBAAkB;EAClE;AACF;;AAEA,6CAA6C;;;;AAI7C;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;IACd,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;;AAEhC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;CACnB,yBAAyB;CACzB,aAAa;AACd;;AAEA;CACC,6BAA6B;CAC7B,mBAAmB;CACnB,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,QAAQ;CACR,UAAU;CACV,wBAAwB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,aAAa;IACX,sBAAsB;IACtB,UAAU;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;IACxC,WAAW;IACX,yCAAyC;IACzC,qBAAqB;IACrB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,cAAc;EACd,gBAAgB,EAAE,+CAA+C;EACjE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;;;;AAKA;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,kBAAkB,EAAE,qBAAqB;EACzC,gBAAgB;EAChB,gBAAgB;;AAElB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;;AAEZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;;AAEhB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,oCAAoC;IAClC,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;;;AAIA,aAAa;;AAEb;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,WAAW;;AAEb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;;EAEnB;;;yCAGmgB;;EAEngB,2BAA2B;EAC3B,qDAAqD;EACrD,mDAAmD;;EAEnD,6CAA6C;AAC/C;;AAEA;EACE;IACE,0DAA0D;EAC5D;AACF;;AAEA;EACE,WAAW;IACT,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,WAAW;IACX,8BAA8B;IAC9B,qCAAqC;IACrC,UAAU;AACd;;;AAGA,kCAAkC;;AAElC;;EAEE,cAAc,EAAE,2DAA2D;AAC7E;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;;AAEnD;;AAEA;EACE,IAAI,yBAAyB,EAAE,EAAE,4CAA4C;EAC7E,MAAM,4BAA4B,EAAE,CAAC;;;;AAIvC;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;IACX,sBAAsB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;CACC,cAAc;CACd,UAAU;CACV,SAAS;CACT,mBAAmB;CACnB,+BAA+B;CAC/B,qBAAqB;CACrB,kEAAkE;EACjE,yDAAoD;EACpD,iBAAiB;EACjB,kBAAkB;AACpB,eAAe,CAAC;;EAEd;IACE,kCAAkC;IAClC,6CAA6C;EAC/C;;;AAGF;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;;AAErB;AACA,4EAA4E;;AAE5E;EACE,aAAa;IACX,2DAA2D;IAC3D,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;;;AAG5B;;AAEA;EACE,SAAS;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;EACE,SAAS;IACP,aAAa;IACb,mBAAmB;AACvB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;MACI,uBAAuB;EAC3B;EACA;MACI,yBAAyB;EAC7B;AACF;;AAYA;AACA,WAAW;AACX,YAAY;AACZ,iBAAiB;AACjB,mCAAmC;AACnC,kBAAkB;AAClB,+BAA+B;AAC/B,gCAAgC;CAC/B,oCAAoC;EACnC,2CAA2C;EAC3C,wCAAwC;EACxC,4CAA4C;EAC5C,yCAAyC;;KAEtC,4BAA4B;EAC/B,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,0GAA0G;;AAE1G;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB,UAAU;EACR,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;;;AAGrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;IACX,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;EACZ,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;;AAEtB;;AAEA;EACE,6CAA6C;EAC7C,aAAa;IACX,SAAS;IACT,kBAAkB;AACtB;;AAEA;EACE,kCAAkC;EAClC,aAAa;IACX,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,UAAU;IACV,mBAAmB;AACvB;;;;AAIA;EACE,+CAA+C;EAC/C,oBAAoB;;AAEtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;IACX,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;EACZ,mBAAmB;AACrB;;;AAGA;EACE,kDAAkD;EAClD,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,aAAa;IACX,SAAS;IACT,iBAAiB;AACrB;;AAEA;EACE,kCAAkC;EAClC,aAAa;IACX,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA,2FAA2F;AAC3F;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6FAA6F;;AAE7F;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;EAClC,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;IAChB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,eAAe;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;;;AAGrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;GAGG;;AAEH;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,yDAAsD;EACtD,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;;;;AAKA;EACE,aAAa;EACb,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,SAAS;EACT,SAAS;EACT,oBAAoB;EACpB,qCAAqC;EACrC,sCAAsC;EACtC,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;AAClB;;;AAGA,cAAc;AACd;CACC,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,uBAAuB;CACvB,4BAA4B;CAC5B,mBAAmB;;CAEnB,4BAA4B;CAC5B,8DAA8D;AAC/D;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB,CAAC;;EAE1B;IACE,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,yBAAyB,CAAC;;;AAG9B;EACE;EACA;EACA,aAAa;EACb,mBAAmB;EACnB,WAAW;;AAEb;;AAEA;EACE,iBAAiB;AACnB;;;AAGA,qDAAqD;;AAErD;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB,EAAE,+BAA+B;EACvD,mBAAmB,EAAE,mDAAmD;EACxE,gBAAgB;AAClB;;;;;;;AAOA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;;EAEhB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,4BAA4B,EAAE,+BAA+B;EAC7D,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,+BAA+B;EAC1D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,4BAA4B,EAAE,+BAA+B;EAC7D,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;AAClE;;;AAGA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,UAAU;IACR,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;;AAEtB;;;AAGA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA,oIAAoI;AACpI;;EAEE;IACE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;;EAEf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;AACpB;;EAEE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;;EAEZ;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;;EAEhB;;;;;AAKF;EACE,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,sBAAsB;IACpB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;;;;;AAMA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;;AAE7B;AACA;;AAEA,kHAAkH;AAClH;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,6BAA6B;AACjC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;;EAGE;IACE,sBAAsB;IACtB,SAAS;;EAEX;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;IACR,eAAe;IACf,iBAAiB;;EAEnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB;EACF;;EAEA;IACE,WAAW;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;;;;EAKE;IACE,aAAa;IACb,cAAc;EAChB;;AAEF;EACE,yDAA6C;EAC7C,2BAA2B;EAC3B,yBAAyB;EACzB;;;AAGF;EACE,eAAe;AACjB;;;;AAIA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC,EAAE,qCAAqC;;AAE9E;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;;;AAGxB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;EACE,WAAW;AACb;;AAEA;;EAEE,kBAAkB;;AAEpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;;;;AAKA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;;AAGA;;EAEE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA","sourcesContent":[":root {\n  --hydrosblue: #205673;\n  --hydrosorange:#DA6B51;\n  --hydroslightblue:#327F98;\n  --hydrosyellow:#FDEDC4;\n}\n\n\n\n\n.App {\n  text-align: center;\n  overflow-x: hidden;\n  min-height: 87vh;\n  overflow-y: hidden;\n}\n\n.white-paragraph {\n  color: white;\n  font-size: 18px;\n  font-weight: 500;\n  text-align: justify;\n}\n\n.question_container {\n  margin:auto;\n  margin-top: 2vh;\n  border-width: 4px;\n  border-color: var(--hydrosblue);\n  border-style: solid;\n  border-radius: 20px;\n  padding: 2vw;\n  min-width: 25rem;\n  z-index: 22;\n  position: relative;\nmin-width: 18rem;\nmargin-bottom: 1rem;}\n\n.graphique_empreinte_div {\n  margin: auto;\n  min-width: 20rem;\n}\n\n.question-graphique-title {\n  text-align: left;\n  color: var(--hydrosblue);\n  z-index: 22;\n  position: relative;\n  transform: translate3d(0, 0, 0);\n  margin: 0REM;\n  font-weight: bolder;\n}\n\n.global-question-container {\n  margin: auto;\n  width: 85%;\n  max-width: 110vh;\n}\n\n.question-total {\n  text-align: right;\n  color: var(--hydrosblue);\n  font-size: xx-large;\n  border: solid 5px var(--hydrosorange);\n  border-radius: 20px;\n  padding: 0.25rem;\n}\n\n.question_info_container {\n  text-align: left;\n  background-color: #F7F7F7;\n  border-radius: 25PX;\n  padding: 1rem;\n}\n\n.text_info {\n  text-align: left;\n  margin-bottom: 1vh;\n}\n\n.question_title_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: left;\n  align-items: center;\n  margin-bottom: 1vh;\n}\n\n.question-total-container {\n    border-radius: 25px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: -10px;\n}\n\n.question_title {\n  font-size: x-large;\n  padding-right: 1vw;\n  text-align: left;\n}\n.navigation_container {\n  display: flex;\n  justify-content: right;\n  margin-top: 25px;\n}\n\n.button-hydros {\n  align-items: center;\n  background-color: var(--hydrosblue);\n  border: 0;\n  border-radius: 100px;\n  box-sizing: border-box;\n  color: #ffffff;\n  cursor: pointer;\n  display: inline-flex;\n  font-family: 'Marianne', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  justify-content: center;\n  line-height: 20px;\n  max-width: 480px;\n  min-height: 40px;\n  min-width: 0px;\n  overflow: hidden;\n  padding: 0px;\n  padding-left: 20px;\n  padding-right: 20px;\n  text-align: center;\n  touch-action: manipulation;\n  transition: background-color 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s,\n    box-shadow 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s,\n    color 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s;\n  user-select: none;\n  -webkit-user-select: none;\n  vertical-align: middle;\n  margin-left: 2vw;\n  cursor: pointer;\n  width: fit-content;\n}\n\n.button-hydros:hover,\n.button-hydros:focus,.boutton-sensibiliser:hover,.boutton-sensibiliser:focus {\n  background-color:  rgb(29, 77, 104)!important;\n  color: #ffffff;\n}\n\n.boutton-commencer:hover,.boutton-commencer:focus {\n  background-color:  #C46049;\n  color: #ffffff;\n}\n\n\n\n.button-hydros:active{\n  background: #09223b;\n  color: rgb(255, 255, 255, 0.7);\n}\n  \n\n.button-hydros:disabled {\n  cursor: not-allowed;\n  background: rgba(0, 0, 0, 0.08);\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.boolean-button {\n  align-items: center;\n  background-color: rgb(255, 255, 255);\n  border-color: rgb(227, 227, 219);\n  border-radius: 12px;\n  border-style: solid;\n  border-width: 2px;\n  padding: 1vh 2vh;\n  width: fit-content;\n  margin: 0.5vh;\n  cursor: pointer;\n}\n\n.selected {\n  align-items: center;\n  background-color: rgb(255, 255, 255);\n  border-color: var(--hydrosblue);\n  border-radius: 12px;\n  border-style: solid;\n  border-width: 2px;\n  padding: 1vh 2vh;\n  width: fit-content;\n  margin: 0.5vh;\n  font-size: initial;\n}\n\n.empreinte-eau-definition {\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n\n  text-align: left;\n  padding: 0vw 5vw;\n  padding-bottom: 3vw;\n\n  background-color: var(--hydrosorange);\n}\n\n\n.hydros-teaser-title {\n  color: white;\n  font-size: 40px;\n  text-align: center;\n}\n\n.hydros-text-white {\n  color: white;\n  font-size: 20px;\n  text-align: justify;\n}\n\n.hydros-image {\n  width: 100%;\n}\n\n\n\n\n\n.not-selected {\n  align-items: center;\n  background-color: rgb(255, 255, 255);\n  border-color: rgb(227, 227, 219);\n  border-radius: 12px;\n  border-style: solid;\n  border-width: 2px;\n  padding: 1vh 2vh;\n  width: fit-content;\n  margin: 0.5vh;\n  font-size: initial;\n}\n\n.selected:hover, .not-selected:hover {\n  background-color: rgb(240 244 253);\n}\n\n.choices_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n\n.typeJsText {\n  min-width: 10%;\n  text-align: left;\n}\n\n.arrow-img {\n  height: 2vh;\n  width: 2vh;\n}\n.info-img {\n  height: 4vh;\n  width: 4vh;\n  cursor: pointer;\n}\n\n.info-empreinte {\n  height: 4vh;\n  width: 4vh;\n  cursor: pointer;\n}\n\n.info-action {\n  cursor: pointer;\n  height: 2.5vw;\n    width: 2.5vw;\n    min-height: 2rem;\n    min-width: 2rem;\n}\n\n\n.results-img {\n  height: 1.25rem;\n  width: 1.25rem;\n  z-index: 22;\n  position: relative;\n}\n\n\n.graph-results-img {\n  width: 5vw;\n  min-height: 2rem;\n  min-width: 2rem;\n  cursor: pointer;\n}\n\n.graph-results-title {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.graph-title-and-results-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1vh;\n  width: 100%;\n}\n\n.mosaic-option-img {\n  height: 6vh;\n  width: 6vh;\n\n}\n.boutton-commencer {\n  align-items: center;\n  background-color: var(--hydrosorange);\n  border-color: var(--hydrosorange);\n  border-radius: 25px;\n  border-style: solid;\n  border-width: 2px;\n  color: white;\n  padding: 20px 40px;\n  font-size: large;\n  cursor: pointer;\n  font-weight: bold;\n  z-index: 9999;\n  position: RELATIVE;\n  text-decoration: none;\n}\n\n.boutton-orange {\n  color: var(--hydrosorange)!important;\n  background-color: white!important;\n}\n\n.close_text_info_button  {\n  margin-left: 0vw!important;\n}\nh1 {\n  font-size: x-large;\n  font-weight: bold;\n  color:  var(--hydrosblue);\n}\n\nh2 {\n  font-weight: 500;\n}\n\n.header-container {\n  top: 0; \n  left: 0;\n  width: 100%; \n  background-color: white; \n  z-index: 1000; \n  border-bottom: solid rgb(227, 227, 219) 1px;\n  background-color: var(--hydrosblue);\n  \n  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, ;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 100rem;\n\n  color: white;\n  padding: 0.5rem 2rem;\n  \n  \n}\n\n.footer {\n  display: flex;\n  flex-direction: row;\ngap: 3vw;\njustify-content: center;\nbackground-color: var(--hydrosblue);\ncolor: white;}\n\n\n.header-content, .footer-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-size: large;\n  cursor: pointer;\n  gap: 1rem;\n}\n\n.no-link {\n  color:white;\n  text-decoration:none\n}\n\n\n\n.compte-gouttes-icon, .compte-gouttes-footer-icon {\n  width: 24vH;\n  cursor: pointer;\n}\n\n.ademe-icon {\n  height: 6vw;\n  cursor: pointer;\n}\n\n.liste-icon {\n  height: 5vh;\n  width: 5vh;\n}\n\n.hamburger-icon {\n  display: none;\n  height: 6vh;\n  width: 6vh;\n}\n\n.dynamic-text {\n  width: 100%;\n  flex-wrap: wrap;\n  display: flex;\n  gap: 6px;\n  margin-left: auto;\n}\n.paragraphe-nos-gestes {\n  display: flex;\n  flex-direction: row;\n  padding: 10vh 0vh;\n  justify-content: center;\n  margin-right: auto;\n  margin-left: auto;\n  max-width: 80%;\n  padding: 0vh 3vw;\n  gap: 7rem;\nalign-items: center;\ntext-align: center;\nmargin-top: -40px;\nmargin-bottom: 5%;\n}\n\n.paragraphe-empreinte-eau {\n  display: flex;\n  flex-direction: row;\n  padding: 10vh 0vh;\n  justify-content: center;\n  margin-right: auto;\n  margin-left: auto;\n  max-width: 65vw;\n  padding: 0vh 3vw;\n  gap: 7rem;\n  align-items: center;\n  text-align: center;\n  margin-top: -205px;\n}\n\n.description-seo-text {\n  text-align: justify;\n}\n\n.parent-paragraphe-empreinte-eau {\n  background-color: var(--hydrosblue);\n  padding-bottom: 4rem;\n}\n\n\n\n.paragraphe-nos-gestes-title {\n  color: var(--hydrosblue);\nfont-size: x-large;\njustify-content: center;}\n\n.hydros-teaser-left-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.img-atelier-compte-gouttes {\n  max-width: 130%;\n}\n\n.img-hydros-teaser {\n  max-width: 100%;\n}\n\n.img-plus-loin {\n  max-width: 45%;\n}\n\n.wf-paragraphe {\n  background-color: rgb(243 244 246);\n}\n\n.home-button-new-form {\n  position: relative;\n  z-index: 9999;\n  cursor: pointer;\n  margin-top: 15px;\n  /* color: var(--hydrosblue); */\n  color: #000b10;\n}\n\n.home-button-new-form:hover {\n  text-decoration: underline;\n}\n\n\n\n.home-separator {\n  display: block;\n position: relative;\n top: -2px;\n height: 178px;\n background-image: url('data:image/svg+xml;utf8,<svg viewBox=\"0 0 1263 178\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 0 0 C 44 0 44 50 88 50 L 88 50 L 88 0 L 0 0 Z\" stroke-width=\"0\"></path> <path fill=\"rgba(32, 86, 115, 1)\" d=\"M 87 50 C 128.5 50 128.5 8 170 8 L 170 8 L 170 0 L 87 0 Z\" stroke-width=\"0\"></path> <path fill=\"rgba(32, 86, 115, 1)\" d=\"M 169 8 C 254.5 8 254.5 94 340 94 L 340 94 L 340 0 L 169 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 339 94 C 415 94 415 51 491 51 L 491 51 L 491 0 L 339 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 490 51 C 525.5 51 525.5 82 561 82 L 561 82 L 561 0 L 490 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 560 82 C 607.5 82 607.5 34 655 34 L 655 34 L 655 0 L 560 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 654 34 C 719 34 719 57 784 57 L 784 57 L 784 0 L 654 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 783 57 C 857.5 57 857.5 4 932 4 L 932 4 L 932 0 L 783 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 931 4 C 1021.5 4 1021.5 42 1112 42 L 1112 42 L 1112 0 L 931 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 1111 42 C 1187 42 1187 0 1263 0 L 1263 0 L 1263 0 L 1111 0 Z\" stroke-width=\"0\"></path></svg>');\n background-size: cover;\n background-repeat: no-repeat;\n }\n\n .home-separator-bottom {\n  display: block;\n position: relative;\n top:  -215px;\n height: 235px;\n background-image: url('data:image/svg+xml;utf8,<svg viewBox=\"0 0 1263 213\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 0 77 C 28 77 42 52 70 52 L 70 52 L 70 0 L 0 0 Z\" stroke-width=\"0\"></path> <path fill=\"rgba(32, 86, 115, 1)\" d=\"M 69 52 C 123.80000000000001 52 151.2 78 206 78 L 206 78 L 206 0 L 69 0 Z\" stroke-width=\"0\"></path> <path fill=\"rgba(32, 86, 115, 1)\" d=\"M 205 78 C 289.4 78 331.6 21 416 21 L 416 21 L 416 0 L 205 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 415 21 C 459.4 21 481.6 93 526 93 L 526 93 L 526 0 L 415 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 525 93 C 563.8 93 583.2 69 622 69 L 622 69 L 622 0 L 525 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 621 69 C 652.6 69 668.4 95 700 95 L 700 95 L 700 0 L 621 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 699 95 C 749.8 95 775.2 43 826 43 L 826 43 L 826 0 L 699 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 825 43 C 913 43 957 96 1045 96 L 1045 96 L 1045 0 L 825 0 Z\" stroke-width=\"0\"></path><path fill=\"rgba(32, 86, 115, 1)\" d=\"M 1044 96 C 1131.6 96 1175.4 31 1263 31 L 1263 31 L 1263 0 L 1044 0 Z\" stroke-width=\"0\"></path></svg>');\n background-size: cover;\n background-repeat: no-repeat;\n transform: rotate(180deg);\n }\n \n \n /* @media (max-width:1246px) {\n  .home-separator, .home-separator-bottom {\n    background-size: contain;\n  }\n } */\n \n\n.suggestion_container {\n  padding: 4vh;\n  text-align: right;\n  padding-right: 0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.answer_container {\n  text-align: right;\n}\n\n.answer_input {\n  border: 2px solid rgb(227, 227, 219);\n  border-radius: 12px;\n  padding: 1vh;\n  margin-left: 1vw;\n}\n\n.checkbox-round {\n  width: 1.3em;\n  height: 1.3em;\n  background-color: white;\n  border-radius: 50%;\n  vertical-align: middle;\n  border: 1px solid #696969;\n  appearance: none;\n  -webkit-appearance: none;\n  outline: none;\n  cursor: pointer;\n}\n\n.checkbox-round:checked {\n  background-color: var(--hydrosblue);\n    border: WHITE 2px solid;\n    outline: var(--hydrosblue) solid 2px;\n}\n\ninput[type=\"checkbox\"] {\n  margin-right: 0.5vw;\n}\n\n.paragraph1-flex-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 32rem;\n  /* background-image: url('../public//img/11.svg'); */\n  background-image: url('../public//img/home_img.jpeg'); \n  background-position: bottom;\n  background-size: contain;\n  background-repeat: no-repeat;\n  padding: 3vh;\n  padding-bottom: 14vh;\n  background-color: rgba(255, 255, 255, 0.8); /* Couleur de fond avec opacité */\n  margin-top: 0px;\n}\n\n.plus-loin-container {\n  display: flex;\n  gap: 10rem;\n\n}\n.splash-img {\n  position: absolute;\n  left: 0;\n}\n\n.paragraph1-text {\n  width: 70%;\n}\nstrong {\n  color: var(--hydrosblue);\n  font-weight: 500;\n}\n\n.header-right {\n  gap: 6rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.header-left {\n  gap : 6rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.header-slider {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 5000;\n  background-color: white;\n  display: none;\n  width: 14rem;\n}\n\n.header-slider-container {\n  padding: 2vh;\n  padding-top: 6vh;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  gap: 1vh;\n  background-color: var(--hydrosblue);\n  color: white;\n}\n\n.profile-icon-phone {\n  height: 3vw;\n  width: 3vw;\n  min-width: 1rem;\n  min-height: 1rem;\n  margin-right: 1rem;\n}\n\n.header-slider-item {\n  padding: 0.5rem;\n  cursor: pointer;\n}\n\n/*image hamburger to cross transition*/\n.container {\n  position: relative;\n  padding: 1.5rem;\n}\n\n.menu-toggle {\n  position: relative;\n  right: 1.5rem;\n  top: 49%;\n  transform: translate(0, -50%);\n  height: 26px;\n  width: 29px;\n  z-index: 9999;\n  display: none;\n  cursor: pointer;\n\n  &, &:hover {\n    color: #000;\n  }\n}\n\n.menu-toggle-bar {\n  display: block;\n  position: absolute;\n  top: 50%;\n  margin-top: -1px;\n  right: 0;\n  width: 100%;\n  height: 4px;\n  border-radius: 4px;\n  background-color: white;\n  transition: all 0.3s ease;\n}\n\n.menu-toggle-bar.menu-toggle-bar--top {\n  transform: translate(0, -8px);\n}\n\n.menu-toggle-bar.menu-toggle-bar--middle {\n}\n\n.menu-toggle-bar.menu-toggle-bar--bottom {\n  transform: translate(0, 8px);\n}\n\n.nav-open .menu-toggle-bar.menu-toggle-bar--top {\n  transform: translate(0, 0) rotate(45deg);\n}\n\n.nav-open .menu-toggle-bar.menu-toggle-bar--middle {\n  opacity: 0;\n}\n\n.nav-open .menu-toggle-bar.menu-toggle-bar--bottom {\n  transform: translate(0, 0) rotate(-45deg);\n}\n\n\n.mosaic-options {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2vh; \n  padding: 2vh;\n}\n\n.mosaic-option {\n  display: flex;\n  background-color: white;\n  border-radius: 25px;\n  border: solid 2px rgb(227, 227, 219);\n  padding: 2vh 1vw;\n  gap: 1vh;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.number-input {\n  border: none;\n  width: 3vw;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.mosaic-number-input-container {\n  display: flex;\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0; /* Optional: Remove default margin */\n}\n\n.suggestions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: flex-end;\n  padding-top: 10px;\n  \n}\n\n/* For Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield; /* Reset Firefox style */\n}\n\n\n.navigation-links {\n  display: flex;\n  gap: 2vw;\n  padding: 2vh 0px;\n  flex-wrap: wrap;\n}\n\n.footer-logo {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.footer-navigation {\n  display: flex;\n  gap:5rem;\n  width: -webkit-fill-available;\n  max-width: 60vw;\n}\n\n\n.results-direct {\n  background-color: rgb(162, 210, 253);\n  height: 6vh;\n  border: solid 1px white;\n  align-content: center;\n  justify-content: center;\n  display: FLEX;\n  padding-top: 0.5vh;\n  padding-bottom: 0.5vh;\n}\n\n.results-indirect {\n  background-color: rgb(162, 210, 253);\n  height: 6vh;\n  border: solid 1px white;\n  align-content: center;\n  justify-content: center;\n  display: FLEX;\n  padding-top: 0.5vh;\n  padding-bottom: 0.5vh;\n  min-width: 4rem;\n}\n\n.results-ul {\n   list-style-type:none;\n   padding: 0; \n   display: flex;\n   z-index: 22;\n    position: relative;\n    transform: translate3d(0, 0, 0);\n   \n}\n\n.component-graphique-vague-container {\n  \n}\n\n.results-vague {\n  list-style-type:none;\n  padding: 0; \n  display: flex;\n  align-items: center;\n  \n  width: 5rem;\n  /* animation: animate 4s infinite; */\n  flex-direction: column;\n  border-radius: 25px;\n  position: absolute;\n  height: 100%;\n  top: 0;\n  left:0;\n  z-index: 1;\n  height: 30rem;\n}\n\n.results-vague:nth-child(2) {\n  background: #7dd3fc;\n  animation-name: animate;           \n  animation-duration: 4s;            \n  animation-delay: 0s; \n  \n  z-index: 2;\n}\n\n\n\n\n\n.circle-img {\n  border-radius: 50%;\n    width: 6vh;\n    height: 6vh; \n    background-color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.circle-plus-loin {\n  border-radius: 50%;\n    width: 15vh;\n    height: 15vh; \n    background-color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.titre-container {\n  height: 5rem;\n  align-items: center;\n  display: flex;\n  align-content: center;\n}\n.titre {\n  border-radius: 25px;\n  background-color: white;\n  color: var(--hydrosblue);\n  padding: 0.5rem;\n  max-width: 10rem;\n    font-size: large;\n    font-weight: bold;\n  \n}\n\n.results-page {\n  margin-top: 12vh;\n}\n\n.results-principaux {\n  height: 4vh;\n    border: solid 1px white;\n    align-content: center;\n    justify-content: center;\n    display: FLEX;\n    min-width: 3vw;\n    padding-top: 0.5vh;\n    padding-bottom: 0.5v\n}\n\n.results-direct:first-of-type, .results-indirect:first-of-type{\n  border-top-left-radius: 25px;\n  border-bottom-left-radius: 25px;\n}\n\n.results-indirect:last-of-type, .results-direct:last-of-type {\n  border-top-right-radius: 25px;\n  border-bottom-right-radius: 25px;\n}\n\n.graphique-vague-container {\n  justify-content: center;\n  position: relative;\n  height: 30rem;\n  margin-bottom: 2rem;\n \n}\n\n/*vague qui se remplit plus le questionnaire avance*/\n\n\n.results-vague::after {\n  content: \"\";\n  position: absolute;\n  width: 29REM; /* default value */\n  height: 29REM;\n  left: 55%;\n  background-color: rgba(255, 255, 255, 0.18);\n  border-radius: 70%;\n  -webkit-transform: translateX(-50%) rotate(0);\n  transform: translateX(-50%) rotate(0);\n  -webkit-animation: rotate 6s linear infinite;\n  animation: rotate 6s linear infinite;\n  z-index: 10;\n  margin-top: var(--pseudo-margin, -1rem);\n}\n\n.results-vague::after {\n  border-radius: 30%;\n  /* background-color: rgba(91, 9, 9, 0.9); */\n  background-color: white;\n\n  -webkit-animation: rotate 10s linear -5s infinite;\n  animation: rotate 10s linear -5s infinite;\n  z-index: 20;\n}\n\n\n@keyframes rotate {\n  100% {\n      transform: translateX(-50%) rotate(360deg); /* Full rotation */\n  }\n}\n\n/* wave effect pour empreinte eau indirecte */\n\n\n\n.empreinte-eau-type {\n  z-index: 22;\n  position: relative;\n}\n\n.results-box {\n  border: solid 5px #DB6C52;\n  border-radius: 25px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 60%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-bottom: 2vh;\n  margin-top: 2vh;\n  background-color: lightblue;\n  border-top: none;\n}\n\n.results-france {\n  border: solid 5px var(--hydrosblue);\n  border-radius: 25px;\n  width: 17%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0.5rem;\n  position: relative;\n  margin-left: 3rem;\n}\n\n.partager-results {\n  border-radius: 25px;\n  width: 17%;\n  display: flex;\n  flex-direction: column;\n  gap:2rem;\n  padding: 0.5rem;\n  margin-top: auto;\n    margin-bottom: auto;\n    margin-left: 3rem;\n    align-items: center;\n  border: solid 5px gray;\n}\n\n.results-info {\n  border: solid 5px GRAY;\n  border-radius: 25px;\n  width: 60%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  \n}\n\n.results-title {\n  display: flex;\n  justify-content: flex-start;\n  padding-bottom: 0.5rem;\n  font-size: x-large;\n  z-index: 22;\n  align-items: center;\n  gap: 1vw;\n  text-align: left;\n  position: relative;\n  z-index: 22;\n  height: 3rem;\n  padding-left: 1rem;\n}\n\n.mon-empreinte-eau {\n  height: 4rem;\n}\n\n.grands-postes-title {\n  display: flex;\n  justify-content: flex-start;\n  padding: 1rem;\n  font-size: x-large;\n  z-index: 22;\n  align-items: center;\n  gap: 1vw;\n  text-align: left;\n  position: relative;\n  z-index: 22;\n  width: 80%;\n  margin-left: 10%;\n  margin-right: 10%;\n  color:var(--hydrosblue);\n}\n\n.progression {\n  height: 12px;\n  margin-top: 1vh;\n  border-radius: 25px;\n  margin-left: auto;\n  margin-right: auto;\n background-color: #F7F7F7;\n color:#F7F7F7;\n}\n\n.progress-done {\n\tbackground: var(--hydrosblue);\n\tborder-radius: 20px;\n\tcolor: #fff;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 100%;\n\twidth: 0;\n\topacity: 0;\n\ttransition: 1s ease 0.3s;\n}\n\n.dialogue {\n  border-radius: 50px;\n  border: solid 1px BLACK;\n  PADDING: 15px;\n  width: 7rem;\n  height: min-content;\n  cursor: pointer;\n}\n\n.dialogue_clic {\n  border-radius: 50px;\n  background-color: #f7f7f7;\n  PADDING: 15px;\n  height: min-content;\n  cursor: pointer;\n  position: relative;\n  text-align: justify;\n  font-style: italic;\n  padding-left: 28px;\n  padding-right: 28px;\n  font-size: 14px;\n}\n\n.walter-icon-behind {\n  height: 3rem;\n  width: 3rem;\n  position: absolute;\n  top: -30px;\n  left: 30px;\n  cursor: pointer;\n}\n\n.walter-icon-base {\n  height: 6rem;\n  cursor: pointer;\n}\n\n.results-empreinte {\n  display: flex;\n  justify-content: flex-end;\n  padding: 1rem;\n  font-size: xx-large;\n  font-weight: 500;\n  border-top: dotted 5px gray;\n  z-index: 22;\n  position: relative;\n  height: 3rem;\n}\n\n.results-equivalent {\n    display: flex;\n    justify-content: flex-start;\n    padding-bottom: 0.5rem;\n    z-index: 22;\n    align-items: center;\n    gap: 1vw;\n    text-align: left;\n    position: relative;\n    z-index: 22;\n    height: 3rem;\n    padding-left: 1rem;\n}\n.page-results-img {\n  height: 3rem;\n  width: 3rem;\n}\n\n.france-img {\n  height: 5vw;\n  width: 5vw;\n  min-height: 2rem;\n  min-width: 2rem;\n}\n\n.carousel-img {\n  height: 5vw;\n  width: 5vw;\n  min-height: 3rem;\n  min-width: 3rem;\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n\n.eau-img {\n  height: 2vw;\n  width: 2vw;\n  min-height: 1rem;\n  min-width: 1rem;\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n\n.results-box-container {\n  display: flex;\n  flex-direction: row;\n  width: 80%;\n  margin-left: 10%;\n  margin-right: 10%;\n  margin-bottom: 3%;\n  gap: 0px;\n  justify-content: center;\n}\n\n.main-results {\n  display: flex;\n    flex-direction: column;\n    width: 80%;\n  margin-left: 10%;\n  margin-right: 10%;\n}\n\n.circle {\n  width: 2.5rem; \n  height: 2.5rem; \n  border: solid 2px black;\n  border-radius: 50%; \n  padding: 0.5rem; \n  display: flex; \n  align-items: center; \n  justify-content: center; \n  box-sizing: border-box; \n}\n\n.results-one {\n  BACKGROUND-COLOR: #F7F7F7;\n  border-radius: 25px;\n  PADDING: 1rem 1REM;\n  display: flex;\n  gap: 2rem;\n  margin-top: 2vh;\n  align-items: center;\n}\n\n.grands-postes-results {\n  background-color: rgba(162, 210, 253, 0.7);\n    height: 3vh;\n    border: solid 0.35rem rgba(162, 210, 253);\n    align-content: center;\n    justify-content: flex-end;\n    display: FLEX;\n    padding-top: 0.5vh;\n    padding-bottom: 0.5vh;\n    min-width: 14%;\n    border-radius: 25px;\n    padding-right: 1rem;\n    align-items: center;\n}\n\n.circle-img-vague {\n  position: relative;\n  display: inline-block;\n}\n\n.circle-img-vague .tooltip {\n  width: 12rem;\n  height: 4rem;\n  border: 1px solid black;\n  text-align: center;\n  border-radius: 25px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  left: 5rem;\n  bottom: 1.5rem;\n  overflow: hidden; /* Ensure wave stays within the border radius */\n  z-index: 22;\n}\n\n.paragraphe-empreinte-eau-container .paragraph1-title, .paragraphe-empreinte-eau-container{\n  color: white!important ;\n}\n\n.paragraph1-title {\n  font-size: 40px;\n}\n\n.agir-blue-title, .action-valeur, .action-title, .total-empreinte,.paragraphe-nos-gestes-item,.paragraphe-nos-gestes-title, .introduction {\n  font-size: 20px;\n  font-weight: 400;\n}\n\n.valeur-agir {\n  font-size: 23px;\n  font-weight: 700;\n}\n\n.introduction {\n  font-size: 25px;\n  color: grey;\n  font-weight: 500;\n}\n\n.empreinte-eau-bloc {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n}\n\n\n\n\n.waves {\n  position:absolute;\n  width: 100%;\n  height:15vh;\n  margin-bottom:-7px; /*Fix for safari gap*/\n  min-height:100px;\n  max-height:150px;\n  \n}\n\n.pie-chart-container {\n  width: 100%;\n  height:100%;\n}\n\n.repartition-container {\n  display: flex;\n  width: 60%;\n  margin-left: auto;\n  margin-right: auto;\n  gap: 0px;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.piecharts-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  color: var(--hydrosblue);\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.total-empreinte {\n  display: flex;\n  color: #6f6f6f;\n  font-size: 24px;\n  padding-bottom: 2vh;\n  font-weight: 500;\n}\n\n.repartition-section-directe {\n  border: solid 5px #DB6C52;\n  border-radius: 25px;\n  padding: 2vh;\n  width: 90%;\n}\n\n.repartition-section-indirecte {\n  border: solid 5px #5E3967;\n  border-radius: 25px;\n  padding: 2vh;\n  margin-left: 3rem;\n  width: 90%;\n}\n\n.agir {\n\n  display: flex;\n  justify-content: space-between;\n}\n\n.action {\n  border: solid 5px rgb(249 205 73);\n  border-radius: 25px;\n  display: flex;\n  justify-content: space-between;\n  padding: 1rem;\n  background-color: rgba(249, 205, 73, 0.218);\n}\n\n.agir-icons{\n  font-size: xxx-large;\n  align-content: center;\n}\n\n.action-valeur {\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column;\n  font-size: 23px;\n  font-weight: 700;\n  color: var(--hydrosblue);\n  align-items: end;\n  margin-top: 5px;\n}\n\n.comment-agir-titre {\n  display: flex;\n  gap: 6vh;\n  width: 80%;\n\n}\n\n.agir-blue-title {\n  font-size: 20px;\n  display: flex;\n  font-weight: 700;\n  align-items: center;\n  gap: 0.5rem;\n  text-align: left;\n}\n\n.percentage-text-agir {\n  font-style: italic;\n  color: #797979;\n}\n\n.agir-percentage-container {\n  text-align: left;\n}\n\n.action-section {\n  width: 80%;\n  margin-left: 10%;\n  margin-right: 10%;\n}\n\n.empreinte-info {\n  background-color:#F7F7F7;\n  border-radius: 25px;\n  padding: 1rem;\n  text-align: justify;\n  padding-left: 2rem;\n  position: relative;\n  margin-top: 40px;\n  word-wrap: break-word;\n  margin-bottom: 0px;\n  font-style: italic;\n  color: #343434;\n\n}\n\n.idee-img {\n  height: 2rem;\n  width: 2rem;\n  position: absolute;\n  left: 0%;\n  top: -15px;\n}\n\n.action-title {\n  /* color: var(--hydrosblue); */\n  color: #1d4c02;\n  font-size: 23px;\n  text-align: left;\n  margin-bottom: 1%;\n  font-weight: 500;\n}\n\n.agir-content {\n  margin-left: 5%;\n  margin-bottom: 5%;\n}\n\n.action-description {\n  margin-top: 10px;\n  text-align: justify;\n}\n\n\n.agir-percentage{\n  background-color: rgb(162, 210, 253);\n    height: 2vh;\n    align-content: center;\n    justify-content: flex-end;\n    display: FLEX;\n    padding-top: 0.5vh;\n    padding-bottom: 0.5vh;\n    min-width: 4rem;\n    border-radius: 25px;\n    padding-right: 1rem;\n    align-items: center;\n    margin-top: 5px;\n}\n\n\n\n/*TEST AGAIN*/\n\n.detail-footprint-question-container {\n  width: 100%;\n}\n\n.box {\n  position: relative;\n  height: 50%;\n  border: solid 5px #DB6C52;\n  border-radius: 25px;\n  z-index: 22;\n  width: 60%;\n}\n\n.tooltip-box {\n  position: relative;\n  height: 50%;\n  border-radius: 25px;\n  z-index: 22;\n \n}\n\n.box-inner {\n  position: relative;\n  width: 100%;\n}\n\n.tooltip {\n  height: 4rem;\n  border: 4px solid var(--hydrosblue)\n}\n\n.tooltip,.tooltip-box:before,.question-box-inner,.box:before,\n.box-inner {\n  background-color: white;\n  border-radius: 21px;\n  \n  background-image: \n  url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='1600' height='198' preserveAspectRatio='none'%3e%3cdefs%3e%3clinearGradient id='a' x1='50%25' x2='50%25' y1='-10.959%25' y2='100%25'%3e%3cstop stop-color='%237dd3fc' stop-opacity='.25' offset='0%25'/%3e%3cstop stop-color='%237dd3fc' offset='100%25'/%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill='url(%23a)' fill-rule='evenodd' d='M.005 121C311 121 409.898-.25 811 0c400 0 500 121 789 121v77H0s.005-48 .005-77z'/%3e%3c/svg%3e\"),\n  url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='1600' height='198' preserveAspectRatio='none'%3e%3cdefs%3e%3clinearGradient id='a' x1='50%25' x2='50%25' y1='-10.959%25' y2='100%25'%3e%3cstop stop-color='%237dd3fc' stop-opacity='.25' offset='0%25'/%3e%3cstop stop-color='%237dd3fc' offset='100%25'/%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill='url(%23a)' fill-rule='evenodd' d='M.005 121C311 121 409.898-.25 811 0c400 0 500 121 789 121v77H0s.005-48 .005-77z'/%3e%3c/svg%3e\"),\n  url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='1600' height='198' preserveAspectRatio='none'%3e%3cdefs%3e%3clinearGradient id='a' x1='50%25' x2='50%25' y1='-10.959%25' y2='100%25'%3e%3cstop stop-color='%237dd3fc' stop-opacity='.25' offset='0%25'/%3e%3cstop stop-color='%237dd3fc' offset='100%25'/%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill='url(%23a)' fill-rule='evenodd' d='M.005 121C311 121 409.898-.25 811 0c400 0 500 121 789 121v77H0s.005-48 .005-77z'/%3e%3c/svg%3e\");\n  \n  background-repeat: repeat-x;\n  background-size: 1600px var(--pseudo-margin-top, 50%);\n  background-position: 0 130%, -50px 130%, 500px 130%;\n  \n  animation: 20s waves linear infinite forwards;\n}\n\n@keyframes waves {\n  to {\n    background-position: 1600px 130%, 3150px 130%, 5300px 130%;\n  }\n}\n\n.results-france:before {\n  content: \"\";\n    position: absolute;\n    top: 7rem;\n    margin-top: -1.75rem;\n    left: -3rem;\n    border: solid 23px transparent;\n    border-right-color: var(--hydrosblue);\n    z-index: 1;\n}\n\n\n/*carousel d'image page d'acceuil*/\n\nbody{\n \n  --Vitesse: 25s; /* Vitesse de défillement (dépend de la longeur du texte) */\n}\n    \n.container-carousel{\n  height: 10vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-left: -57%;\n  margin-bottom: 3rem;\n}\n  \n.text{\n  white-space: nowrap;\n  animation : Scroll var(--Vitesse) linear infinite; \n\n}\n  \n@keyframes Scroll {\n  0% {transform: translateX(0%); } /* inversé 0% et 100% pour inversé le sens */\n  100% {transform: translateX(-100%); }}\n\n\n\n.tshirt-map {\n  width: 70%;\n  margin-top: 30px;\n}\n\n.actions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.green-yellow-purple-gray-map {\n  width: 50%;\n}\n\n.green-yellow-purple-gray-map-container {\n  display: flex;\n  gap: 3rem;\n}\n\n.empreinte-par-pays-container {\n  display: flex;\n    flex-direction: column;\n}\n\n.empreinte-par-pays-div {\n  border-radius: 25px;\n  padding: 0.5rem 0;\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n}\n\n.bg {\n\tdisplay: block;\n\twidth: 50%;\n\theight: 0;\n\tpadding-bottom: 35%;\n\tbackground-position: top center;\n\tbackground-size: 100%;\n\ttransition: background-position 3s ease-in-out, box-shadow 3s ease;\n  background-image: url('../public//img/map_page.png');\n  margin-left: auto;\n  margin-right: auto;\ncursor: pointer;}\n\n  .bg:hover {\n    background-position: bottom center;\n    box-shadow: inset 0 20px 20px rgba(0,0,0,0.2);\n  }\n\n\n.api-vigieau {\n  background-color: #F7F7F7;\n  padding: 15px 30px;\n  border-radius: 50px ;\n  margin-top: 1rem;\n}\n\n.api-vigieau-vigilance {\n  font-Size:'x-large';\n\n}\n/* -----------------CONTACT PAGE-------------------------------------------*/\n\n.contact-page {\n  display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); \n    justify-content: center;\n    gap: 7rem;\n    max-width: 60%;\n    margin-right: auto;\n    margin-left: auto;\n    padding: 0vh 3vw;\n    align-items: center;\n    text-align: left;\n    margin-bottom: 5%;\n    color: var(--hydrosblue);\n  \n  \n}\n\n.form-group {\n  gap: 1rem;\n    display: flex;\n    flex-direction: column;\n}\n\n.results-form {\n  gap: 1rem;\n    display: flex;\n    flex-direction: row;\n}\n\n.formulaire {\n  border-radius: 25px;\n  border: solid 2px BLACK ;\n  margin-bottom: 10px;\n  padding: 10px;\n}\n\n@keyframes loading {\n  from {\n      transform: rotate(0deg);\n  }\n  to { \n      transform: rotate(360deg);\n  }\n}\n\n\n@-webkit-keyframes loading {\n  from {\n      -webkit-transform: rotate(0deg);\n  }\n  to { \n      -webkit-transform: rotate(360deg);\n  }\n}\n\n.load {\nwidth: 20px;\nheight: 20px;\nmargin-left: 30px;\nborder:solid 10px var(--hydrosblue);\nborder-radius: 50%;\nborder-right-color: transparent;\nborder-bottom-color: transparent;\n -webkit-transition: all 0.5s ease-in;\n  -webkit-animation-name:             loading; \n  -webkit-animation-duration:         1.0s; \n  -webkit-animation-iteration-count:  infinite;\n  -webkit-animation-timing-function: linear;\n    \n     transition: all 0.5s ease-in;\n  animation-name:             loading; \n  animation-duration:         1.0s; \n  animation-iteration-count:  infinite;\n  animation-timing-function: linear; \n}\n\n.echec-status {\n  background-color: #fecaca;\n  border-radius: 25px;\n  PADDING: 0.75rem;\n  align-items: center;\n  display: flex;\n  font-weight: bold;\n  width: max-content;\n}\n\n.succes-status {\n  background-color: rgb(247, 255, 247);\n  border-radius: 25px;\n  PADDING: 0.75rem;\n  align-items: center;\n  display: flex;\n  font-weight: bold;\n  width: max-content;\n}\n\n/*-------------------------------------A PROPOS PAGE ----------------------------------------------------*/\n\n.a-propos-paragraphe {\n  background-color: white;\n  display: flex;\n  gap: 10px; \n}\n\n.sensibiliser-paragraphe {\n  display: FLEX;\n  gap: 10px; \n}\n\n.qui-sommes-nous {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\nwidth: 60%;\n  text-align: left;\n  padding: 0vw 5vw;\n  padding-bottom: 1vw;\n  color: var(--hydrosblue);\n  text-align: justify;\n\n  \n}\n\n.hydros-pour-agir {\n  color: white!important;\n  display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: left;\n    padding: 0vw 5vw;\n    padding-bottom: 1vw;\n    width: 60%;\n  text-align: justify;\n}\n\n.hydros-pour-agir-container{\n  background-color: var(--hydrosblue)!important;\n  padding-bottom: 20px;\n \n}\n\n.hydros-pour-agir-paragraphe {\n  background-color: var(--hydrosblue)!important;\n  display: flex;\n    gap: 10px;\n    padding-right: 5vw;\n}\n\n.sensibiliser {\n  color: var(--hydrosblue)!important;\n  display: flex;\n    flex-direction: column;\n    text-align: left;\n    padding: 0vw 5vw;\n    padding-bottom: 2rem;\n    width: 60%;\n    text-align: justify;\n}\n\n\n\n.sensibiliser-container {\n  background-color: var(--hydrosyellow)!important;\n  padding-bottom: 20px;\n\n}\n\n.sensibiliser-paragraphe {\n  align-items: center;\n  padding-right: 5vw;\n}\n\n.mesurer {\n  color: white!important;\n  display: flex;\n    flex-direction: column;\n    text-align: left;\n    padding: 0vw 5vw;\n    padding-bottom: 1vw;\n    width: 60%;\n  text-align: justify;\n}\n\n\n.mesurer-container {\n  background-color: var(--hydroslightblue)!important;\n  padding-bottom: 20px;\n}\n.mesurer-paragraphe {\n  align-items: center;\n  display: FLEX;\n    gap: 10px;\n    padding-left: 5vw;\n}\n\n.inspiration {\n  color: var(--hydrosblue)!important;\n  display: flex;\n    flex-direction: column;\n    text-align: left;\n    padding: 0vw 5vw;\n    padding-bottom: 1vw;\n    width: 80%;\n  text-align: justify;\n}\n\n.inspiration-container {\n  padding-bottom: 20px;\n}\n\n.inspiration-paragraphe {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n}\n\n.inspiration-img-container{\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-around;\n  flex-direction: row;\n  width: 90%;\n  align-items: center;\n}\n\n.inspiration-logo {\n  width: 150px;\n  height: 100%;\n}\n\n\n.boutton-a-propos {\n  padding: 15px 30px!important;\n}\n\n.boutton-sensibiliser {\n  padding: 15px 30px!important;\n  background-color: var(--hydrosblue)!important;\n  border-color: var(--hydrosblue)!important;\n}\n\n.mesurer-empreinte-img-container,.qui-sommes-nous-img-container,.sensibiliser-img-container {\n  width: 40%;\n}\n\n/*-----------------------------------PAGE FAQ ------------------------------------------- */\n.faq-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  line-height: 1.6;\n}\n\n.faq-button-container {\n  text-align: center;\n  margin-bottom: 15px;\n  display: flex;\n  justify-content: center;\n}\n\n.faq-title {\n  text-align: center;\n  color: var(--hydrosblue);\n  margin-bottom: 40px;\n}\n\n.faq-item {\n  margin-bottom: 30px;\n}\n\n.faq-question {\n  font-size: 1.5rem;\n  color: var(--hydroslightblue);\n  margin-bottom: 10px;\n}\n\n.faq-answer {\n  font-size: 1rem;\n  color: #34495e;\n  text-align: justify;\n}\n\n.faq-link {\n  display: inline-block;\n  margin-top: 10px;\n  color: var(--hydrosorange);\n  text-decoration: none;\n}\n\n.faq-link:hover {\n  text-decoration: underline;\n}\n\n/*-----------------------------------PAGE CARTE ------------------------------------------- */\n\n.results-map {\n  border-radius: 25px;\n  display: flex;\n  gap: 2vw;\n  margin-top: 2vh;\n  align-items: center;\n  width:30rem;\n  padding-left: 10%;\n}\n\n.page-map-percentage-bar {\n  align-content: center;\n  justify-content: flex-end;\n  display: FLEX;\n  padding-top: 0.5vh;\n  padding-bottom: 0.5vh;\n  min-width: 14%;\n  border-radius: 25px;\n  padding-right: 1rem;\n  align-items: center;\n  background: var(--hydroslightblue);\n  width: 50%;\n  height: 1px;\n  width: 100%;\n}\n\n.percentage-box {\n  position: relative;\n    height: 50%;\n    border: solid 5px #DB6C52;\n    border-radius: 25px;\n    z-index: 22;\n    width: 100%;\n    padding: 0.5rem;\n}\n\n.comprendre-results {\n  border-radius: 25px;\n  padding: 0.5rem 3%;\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n  \n  \n}\n\n.comprendre-plus-intro {\n  border-radius: 25px;\n  padding: 1rem 1.5rem;\n  margin: 0rem 3%;\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n  background-color: #F7F7F7 ;\n  text-align: justify;\n}\n\n.comprendre-results-box {\n  border: 6px solid var(--hydrosblue);\n  border-radius: 50px;\n  padding: 0.25rem;\n}\n\n.comprendre-results-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.introduction-map {\n  font-size: 20px;\n  color: var(--hydrosblue);\n  font-weight: 500;\n  margin-top: 0px;\n}\n\n/* .map p {\n  color: var(--hydrosblue);\n  font-weight: bold;\n} */\n\n.map-title {\n  color: var(--hydrosblue);\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.comprendre-empreinte-pays-img {\n  width: 3vw;\n  min-height: 2rem;\n  min-width: 2rem;\n}\n\n.comprendre-empreinte-pays-map {\n  border-radius: 25px;\n  display: flex;\n  gap: 2vw;\n  margin-top: 2vh;\n  align-items: center;\n  width:30rem;\n  padding-left: 6%;\n}\n\n\n.blurmap-background-container {\n  background-image: url('../public/img/blur_map_bg.jpg');\n  background-size: cover;\n  background-position: center;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  text-align: center;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n\n\n\n.wsdm-tooltip {\n  display: none;\n  padding: 0.5rem 1rem;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 3px;\n  pointer-events: none;\n  text-align: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  z-index: 1000;\n}\n\n.wsdm-tooltip:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: 100%;\n  left: 50%;\n  margin-left: -0.5rem;\n  border-left: 0.5rem solid transparent;\n  border-right: 0.5rem solid transparent;\n  border-top: 0.5rem solid rgba(255, 255, 255, 0.95);\n}\n\n.results-map {\n  padding-left: 5%;\n}\n\n\n/*légende map*/\n#progress-bar-container {\n\twidth: 4rem;\n\theight: 0.75rem;\n\tborder-radius: 35px;\n\toverflow: hidden;\n}\n\n.progress-bar-child {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.progress {\n\tcolor: white;\n\ttext-align: center;\n\tline-height: 75px;\n\tfont-size: 35px;\n\tfont-family: \"Segoe UI\";\n\tanimation-direction: reverse;\n\tbackground: #e5405e;\n\n\t/* Chrome10-25,Safari5.1-6 */\n\tbackground: linear-gradient(to right, #ffedd5 0%, #ea580c 80%);\n}\n\n.small-circle-legend {\n  width: 0.5rem;\n  height: 0.5rem;\n  border: solid 1px black;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  background-color: #F7F7F7;}\n\n  .circle-legend {\n    width: 0.75rem;\n    height: 0.75rem;\n    border: solid 1px black;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    background-color: #F7F7F7;}\n\n\n.legend-container {\n  color: var(--hydrosblue)\n  ;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  \n}\n\n.legend-container > span {\n  font-weight: bold;\n}\n\n\n/*----------------------------animation apparition  */\n\n.hidden {\n  opacity: 0;\n  transition: all 1s;\n  filter: blur(5px);\n  transform: translateX(-100%);\n}\n\n.show {\n  opacity: 1;\n  filter:blur(0);\n  transform: translateX(0);\n}\n\n.input-container {\n  display: flex;\n  align-items: center;\n  border: 2px solid #666; /* Adjust the color as needed */\n  border-radius: 30px; /* Make sure this is half of the container height */\n  overflow: hidden;\n}\n\n\n\n\n\n\n.send-result-container {\n  margin: 20px;\n  width: 65%;\n  margin-left: 17%;\n  margin-right: 17%;\n  color: var(--hydrosblue);\n}\n\n.form-send-result {\n  display: flex;\n  align-items: center;\n  border: 2px solid #666; \n  border-radius: 30px; \n  overflow: hidden;\n  \n  width: -webkit-fill-available;\n}\n\n.checkbox-consent-container {\n  color: #989898;\n  text-align: left;\n  margin-left: 10px;\n  margin-top: 10px;\n  font-size: 12px;\n  vertical-align: middle;\n}\n\n.email-input {\n  flex: 1;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 30px 0 0 30px; /* Match the container radius */\n  outline: none;\n  font-size: 16px;\n}\n\n.submit-button {\n  background-color: #1e5276; /* Adjust the color as needed */\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 0 30px 30px 0; /* Match the container radius */\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s;\n  border-radius: 25px;\n  font-weight: bold;\n}\n\n.submit-button:hover {\n  background-color: #163a54; /* Darken the button color on hover */\n}\n\n\n.goutte-eau-img {\n  height: 5vw;\n  width: 5vw;\n  min-height: 2rem;\n  min-width: 2rem;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  cursor: pointer;\n}\n\n.couleur-empreinte-container {\n  border: solid 5px var(--hydrosblue);\n  border-radius: 25px;\n  width: 80%;\n    margin-left: 10%;\n    margin-right: 10%;\n    padding-bottom: 1rem;\n    position: relative;\n    \n}\n\n\n.couleur-empreinte-info {\n  background-color: #F7F7F7;\n  border-radius: 25px;\n  padding: 1rem;\n  text-align: left;\n  position: relative;\n  word-wrap: break-word;\n  margin-bottom: 1rem;\n  margin-left: 2rem;\n  margin-right: 2rem;\n  margin-top: 1rem;\n}\n\np {\n  margin-block-start: 0.5em;\n  margin-block-end: 0.5em;\n}\n/*------------------------------------------------------media queries pour petit écran---------------------------------------------*/\n@media (max-width: 1024px) { \n\n  .sensibiliser-titre {\n    margin-bottom: 20px!important;\n  }\n\n  .sensibiliser {\n    padding-bottom: 1vw;\n  }\n\n  .number-input {\n    width: 6vh;\n  }\n\n  .results-vague {\n    width: 3rem;\n  }\n\n  .question_container {\n    margin-top: 3vh;\n  }\n\n  .results-direct,.results-indirect {\n    height: 3vh;\n  }\n\n  .circle-img {\n    width: 3vh;\n    height: 3vh;\n  }\n\n  .paragraph1-flex-container {\n    margin-top: -40px;\n  }\n\n  .repartition-section-directe, .repartition-section-indirecte {\n    width: 80%;\n  }\n\n  .header-content {\n    display: NONE;\n    \n  }\n\n  .menu-toggle {\n    display: block!important;\n  }\n\n  .compte-gouttes-footer-icon {\n    display: none;\n  }\n\n  .ademe-icon {\n    min-width: 2rem;\n    min-height: 2rem;\n}\n\n  .repartition-container {\n    flex-direction: column;\n    align-items: center;\n    width: 90%;\n\n  }\n\n  .repartition-section-indirecte {\n    margin-top: 3rem;\n    margin-left: 0rem;\n  }\n\n  .grands-postes-results {\n    min-width: 25%;\n  }\n\n  .results-box-container {\n    width: 100%;\n    margin-left: 0;\n    \n  }\n\n\n\n\n.comment-agir-titre {\n  width: 100%;\n  gap: 3vh;\n}\n\n.action {\n  flex-direction: column;\n    gap: 1vh;\n    align-items: end;\n}\n\n.agir {\n  padding-bottom: 0;\n  flex-direction: column;\n}\n\n.valeur-agir {\n  margin-bottom: 1rem;\n}\n\n.question_title {\n  font-size: medium;\n}\n\n\n\n\n\n.piecharts-title {\n  text-align: left;\n}\n\n.graph-results-title {\n  text-align: left;\n}\n\nh1 {\n  font-size: x-large;\n}\n\n.paragraph1-text {\n  width: 70%;\n}\n.paragraphe-nos-gestes {\n  margin-left: 0px;\n    margin-right: 0px;\n    max-width: 100%;\n}\n\n.grands-postes-results {\n  height: 2vh;\n}\n\n.agir-percentage{\n  height: 1vh;\n}\n\n.button-hydros, .submit-button, .email-input {\n  font-size: 10px;\n}\n\n.button-hydros {\n  min-height: 35px;\n}\n\n.contact-page {\n  gap: 1rem;\n}\n\n.send-result-container {\n  width: 80%!important;\n  margin-left: 10%!important;\n  margin-right: 10%!important;\n\n}\n}\n\n/*------------------------------------------media queries pour telephone-----------------------------------------*/\n@media (max-width: 768px) {\n\n  .logo-compte-gouttes-bleu {\n    display: none;\n  }\n\n  .titre-container {\n    WIDTH: -webkit-fill-available;\n}\n\n.titre {\n  max-width: -webkit-fill-available;\n  WIDTH: -webkit-fill-available;\n}\n \n\n  .plus-loin-container {\n    flex-direction: column;\n    gap: 1rem;\n    \n  }\n\n  .paragraphe-nos-gestes {\n    flex-direction: column;\n    margin-left: 0px;\n    margin-right: 0px;\n    gap: 0px;\n    max-width: 100%;\n    margin-top: -85px;\n    \n  }\n\n  .paragraphe-empreinte-eau {\n    margin-left: 0PX;\n    margin-right: 0px;\n    MAX-widTH: 100%\n  }\n\n  .paragraph1-text {\n    width: 100%;\n}\n\n.paragraph1-flex-container {\n  margin-top: 0px;\n}\n\n.empreinte-eau-definition {\n  flex-direction: column;\n}\n\n\n  \n\n  .circle {\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n  \n.paragraph1-flex-container {\n  background-image: url('../public//img/3.jpg'); \n  background-position: bottom;\n  background-size: auto 80%;\n  }\n\n\n.img-atelier-compte-gouttes {\n  max-width: 100%;\n}\n\n\n\n.header {\n  align-content: center;\n  padding-right: 2vw;\n}\n\n.mosaic-options {\n  grid-template-columns: repeat(1, 1fr); /* Creates 2 columns of equal width */\n\n}\n\n.navigation-links {\n  flex-direction: column!important;\n}\n\n.footer-logo {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.results-indirect {\n  min-width: 3rem;\n  max-width: 30rem;\n}\n\n.suggestion_container {\n  flex-direction: column;\n  \n  \n}\n\n.results-box-container {\n  flex-direction: column;\n  margin-left: 0;\n  width: 100%;\n  align-items: center;\n  gap: 1rem;\n}\n\n.results-france:before {\n  visibility: hidden;\n}\n\n.results-france {\n  width: 58%;\n  margin-left: 0;\n}\n\n.partager-results {\n  flex-direction: row;\n  justify-content: center;\n  width: 88%;\n  margin-left: 0;\n}\n\n.btn-partage {\n  min-width: 7rem;\n}\n\n.grands-postes-results {\n  min-width: 35%;\n  font-size: x-small;\n}\n\n.grands-postes-title {\n  min-width: 35%;\n  margin-left: 0%;\n}\n\n.results-title{\n  font-size: small;\n}\n\n.btn-partage {\n  padding-top: 5px; \n  padding-bottom: 5px; \n}\n\n.agir-icons {\n  font-size: xx-large;\n}\n\n.results-empreinte {\n  font-size: xx-large;\n}\n\n\n\n.grands-postes-results {\n  height: 1vh;\n}\n\n.results-empreinte {\n\n  border-top: HIDDEN;\n  \n}\n\n.box,.results-info {\n  width: 90%;\n}\n\n.results-france {\n  width: 88%;\n}\n\n.results-info {\n  align-items: center;\n}\n\n.main-results {\n  width: 90%;\n  margin-left: 5%;\n  margin-right: 5%;\n}\n\n.circle-img-vague .tooltip {\n  height: 3rem;\n}\n\n.a-propos-paragraphe,.hydros-pour-agir-paragraphe,.sensibiliser-paragraphe,.mesurer-paragraphe {\n  flex-direction: column;\n  padding-right: 0px;\n  padding-left: 0px;\n}\n\n.qui-sommes-nous,.mesurer-empreinte-img-container,.hydros-pour-agir-img-container,.qui-sommes-nous-img-container,.hydros-pour-agir,.sensibiliser-img-container,.sensibiliser,.mesurer {\n  width: 90%!important;\n  JUSTIFY-CONTENT: CENTER;\n  PADDING: 0 5vw;\n}\n\n.inspiration-img-container{\n  flex-direction: column;\n}\n\n.inspiration-logo {\n  width: 200px;\n  height: 100%;\n  margin-top: 20px;\n}\n\n\n\n\n.qui-sommes-nous-img-container,.sensibiliser-img-container {\n  padding-bottom: 20px;\n}\n\n.contact-page {\n  gap: 1rem;\n}\n\n.green-yellow-purple-gray-map{\n  width: 100%;\n}\n\n.green-yellow-purple-gray-map-container {\n  flex-direction: column;\n}\n\n.page-map-percentage-bar { \n  max-width: 50vw;\n  min-width: 10vw;\n}\n\n.tshirt-map {\n  width: 100%;\n}\n\n.agir-percentage {\n  max-width: 50%;\n}\n.submit-button {\n  padding: 10px;\n}\n\n\n.bg {\n\n  width: 60%!important;\n  padding-bottom: 45%!important;\n}\n\n.api-vigieau-vigilance {\n  font-Size:'medium';\n\n}\n\n.api-vigieau-department-container {\n  text-align: left;\n  flex-direction: column;\n}\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
